import React, { useState, useEffect, useContext, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import IContract from 'src/models/contract_types/IContract';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import AgreementDocs from '../AgreementDocs';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'src/actions';
import DialogList from 'src/dialogs';
import LPRDialog from '../LPRDialog';
import PDFWindow from 'src/components/common/PDFWindow';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import RHFToggle from 'src/components/controls/tempRHFControls/RHFToggle';
import AdHocClauses from './AdHocClauses';
import LeasingTractList from '../LeasingTractList.redesign';
import OwnerUtil from 'src/util/OwnerUtil';
import { IRootState } from 'src/reducers';
import Lease from 'src/models/leasehold/Lease';
import moment from 'moment';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import { push } from 'connected-react-router';
import OwnerJointTenant from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenant';
import ExtendLeaseholdsDialog from '../../tract/dialogs/ExtendLeaseholdsDialog';
import { AnyObject } from 'final-form';
import State from 'src/models/State';
import PagedResultSet from 'src/models/common/PagedResultSet';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import LeaseAmendment from 'src/models/leasehold/LeaseAmendment';
import AcknowledgementList from './AcknowledgementList';
import AcknowledgementType from 'src/models/leasing/AcknowledgementType';
import LeaseClauseType from 'src/models/LeaseClauseType';
import LocationModel from 'src/models/leasing/LocationModel';
import ContractAddendumClauseXRef from './ContractGenerationModels/ContractAddendumClauseXRef';
import MathUtil from 'src/util/MathUtil';
import AethonMemo from '../MemoTemplates/AethonMemo';
import AethonOOP from '../OOPTemplates/AethonOOP';
import IOwner from 'src/models/IOwner';
import Leasehold from 'src/models/leasehold/Leasehold';
import _ from 'lodash';
import ContractAdHocClause from './ContractGenerationModels/ContractAdHocClause';
import ContractAddendumClause from './ContractGenerationModels/ContractAddendumClause';
import ClientApprovedLeaseClauses from '../ClientApprovedLeaseClauses';
import AgreementUtil from 'src/util/AgreementUtil';
import ContractGenerationTractDetail from './ContractGenerationModels/ContractGenerationTractDetail';
import LandContractType from 'src/models/LandContractType';
import AethonLease from '../OGTemplates/AethonTemplate';
import ReportFileDetails from 'src/models/ReportFileDetails';
import * as Constants from 'src/components/common/Constants';
import { LandSystem } from 'src/models/LandSystem';
import CalmsInvoiceData from 'src/models/CalmsInvoiceData';
import ReactQuill from 'react-quill';
import CalmsLeaseRecordData from 'src/models/CalmsLeaseRecordData';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import ProvisionLeaseClause from 'src/models/ProvisionLeaseClause';
import ProvisionClauseType from 'src/models/ProvisionClauseType';
import ProvisionClause from 'src/components/common/ProvisionClause';
import ProvisioningUpdateDto from 'src/models/ProvisioningUpdateDto';
import LeaseholdClauses from 'src/models/leasehold/LeaseholdClauses';
import LiveLeaseWindow, { ILiveLeaseWindowHandle, openLiveLeaseWindow } from '../livePreview/LiveLeaseWindow';
import { LeaseFormSection, leasePreviewTarget } from '../livePreview/leasePreviewTargets';
import { ensureStyles, JUMP_TARGET_CSS } from 'src/components/common/docxPreview/docxPreviewStyles';

// const approviedClauses = [{id: 1, projectId: 3128, LeaseClauseTypeId: 1, ClauseText: 'Depth Pugh'},];

// const dummyData = {
//     id: 1,
//     term: '12',
//     termUnit: 'months',
//     effectiveDate: '12/12/2020',
//     isCommitted: true,
//     committedDate: '12/12/2020',
//     isOptionToExtend: true,
//     isSecondOptionToExtend: false,
//     isAdditionalConsideration: false,
//     tracts: [
//         {
//             includeTract: true,
//             sectionNumber: 1,
//             tractNumber: 15,
//             horizonNumber: 1,
//             tractName: 'testTract',
//             section: 2,
//             township: '3',
//             range: '4',
//             county: {
//                 name: 'testCounty',
//                 id: 1,
//             },
//             legalDescription: 'testLegalDescription',
//             grossAcres: 180,
//             netAcres: 90,
//             decimalInterest: 0.5,
//             leasedStatus: 'leased',
//             id: 1,
//             countyId: 1,
//             horizonId: 1,
//             horizonName: 'testHorizon',
//             ownershipId: 1,
//             leaseId: 1,
//             hasNEMI: false,
//             additionalOwnerships: [{}]
//         }
//     ]
// };

// enum statusType {
//     Committed,
//     InHand,
//     Tranferred
// }

const LeaseGeneration = () => {
    const { register, handleSubmit, errors, watch, setValue, formState, getValues, reset, control } = useForm();
    const { isDirty } = formState;
    const dispatch = useDispatch();

    const agreementTermSection = useRef(null);
    const generInfoSection = useRef(null);
    const lesseeInfoSection = useRef(null);
    const ownerInfoSection = useRef(null);
    const docManagSection = useRef(null);
    const tractListSection = useRef(null);
    const addendumSection = useRef(null);
    const adHocSection = useRef(null);
    const pmSection = useRef(null);
    const pmAdmendmentSec = useRef(null);
    const lrSection = useRef(null);
    const acknowledgementSec = useRef(null);

    // const [pdfFormValues, setPDFFormValues] = useState(undefined);
    const watchExpirationCalcFields = watch(['leasehold.primaryTerm', 'leasehold.primaryTermUnits', 'effectiveDate']);
    const watchOptionFields = watch(['leasehold.renewalOption', 'isAddOptionToExtend', 'isAddConsideration']);
    const watchConsiderationAmount = watch('addConsiderationAmount');
    const watchRentalFields = watch(['rentalAmount', 'rentalPaymentUnit', 'prepaidRental']);
    // const watchAll = watch();
    const { get, response, put, post } = useFetch();
    const [contractClauses, setContractClauses] = useState<ContractAddendumClause[]>(undefined);
    const [tractsSelected, setTractsSelected] = useState<boolean>(false);
    const [leaseClauseTypes, setLeaseClauseTypes] = useState<LeaseClauseType[]>(undefined);
    const appContext = useContext<IAppContextState>(AppContext);
    const [totalGross, setTotalGross] = useState(0);
    const [totalNet, setTotalNet] = useState(0);
    const [ownerData, setOwnerData] = useState<LeaseGenerationOwnerData>(null);
    const { project } = useSelector((state: IRootState) => state);
    const [defaultLessee, setDefaultLessee] = useState<IOwner>(null);
    const [leaseData, setLeaseData] = useState<Lease>(null);
    const [amendments, setAmendments] = useState<LeaseAmendment[]>([]);
    const [newLeaseType, setNewLeaseType] = useState<string>(null);
    const [isNewLease, setIsNewLease] = useState<boolean>(false);
    const [liveLeaseWindow, setLiveLeaseWindow] = useState<Window>(null);
    const liveLeasePreview = useRef<ILiveLeaseWindowHandle>(null);
    const [states, setTractStates] = useState<PagedResultSet<State>>(undefined);
    const [projectContactCategories, setProjectContactCategories] = useState<OwnershipContactCategoryForm>(undefined);
    const [acknowledgementTypes, setAcknowledgementTypes] = useState<AcknowledgementType[]>(undefined);
    const [moveLegalDescription, setMoveLegalDescription] = useState<string>(undefined);
    const [isInHanded, setIsInhanded] = useState(false);
    const [renderTemplate, setRenderTemplate] = useState<number>(undefined);
    const [renderMemo, setRenderMemo] = useState<number>(undefined);
    const [renderOOP, setRenderOOP] = useState<number>(undefined);
    const [rerender, setReRender] = useState<object>({ value: 0 });
    const [adHocClauses, setAdHocClauses] = useState<Array<ContractAdHocClause>>([]);
    const [selectedClauses, setSelectedClauses] = useState<number[]>([]);
    const [leaseTractList, setLeaseTractList] = useState<ContractGenerationTractDetail[]>([]);
    const [originalTractList, setOriginalTractList] = useState<ContractGenerationTractDetail[]>([]);
    const [tractMORList, setTractMORList] = useState<ReportFileDetails[]>(undefined);
    const [invoiceData, setInvoiceData] = useState<CalmsInvoiceData[]>(undefined);
    const [leaseRecordData, setLeaseRecordData] = useState<CalmsLeaseRecordData[]>(undefined);
    const [controllerPath, setControllerPath] = useState<string>('');
    const [hasOlderTemplates, setHasOlderTemplates] = useState<boolean>(false);
    const [parentContractLookupId, setParentContractLookupId] = useState<number>(0);

    // Provisioning
    const [attachedProvisionClauses, setAttachedProvisionClauses] = useState<Array<ProvisionLeaseClause>>(undefined);
    const [provisionClauseTypes, setProvisionClauseTypes] = useState<Array<ProvisionClauseType>>([]);

    // state & county states
    const [counties, setCounties] = useState<string[]>(undefined);
    const [tractState, setTractState] = useState<number>(undefined);
    const [location, setLocation] = useState<LocationModel>(undefined);
    const [isProvisional, setIsProvisional] = useState<boolean>(undefined);
    const [isRealOwnerAttach, setIsRealOwnerAttach] = useState<boolean>(undefined);
    const [deltasAdded, setDeltasAdded] = useState<boolean>(false);
    const [formLoading, setFormLoading] = useState<boolean>(true);
    const [calmsSubmitting, setCalmsSubmitting] = useState<boolean>(false);
    const dialogContext = useContext<dialogCreators>(DialogContext);

    // const watchStatusFields = watch(['isCommitted', 'isInHand'], {
    //     isCommitted: leaseData?.isCommitted ? leaseData?.isCommitted : false,
    //     isInHand: leaseData?.isInHand ? leaseData?.isInHand : false,
    // });

    const initializePage = () => {
        setControllerPath('leases');
        getStates();
        getProjectContactCategories();
        getAcknowledgementTypes();
        getLeaseClauseTypes();
        getProvisionClauseTypes();

        const params = new URLSearchParams(window.location.search);
        if (params.has('leaseType')) {
            setNewLeaseType(params.get('leaseType'));
        }

        if (appContext.ownerId > 0) {
            getOwnerData();
        }

        if (appContext.leaseId > 0) {
            getAmendments();
            getContractClauses();
            getLeaseData();
        } else {
            setIsNewLease(true);
        }
    };

    useEffect(() => {
        initializePage();
    }, []);

    useEffect(() => {
        console.log('rerender so everything shows up!!');
    }, [rerender]);

    useEffect(() => {
        isProvisional === true ? setTotalNet(leaseData?.leasehold?.provisionalNetAcres) : setTotalNet(totalNet);
        isProvisional === true ? setTotalGross(leaseData?.leasehold?.provisionalGrossAcres) : setTotalGross(totalGross);
        setReRender({ value: 1 });
    }, [isProvisional]);

    useEffect(() => {
        if (project?.currentProject?.defaultOwnerLookUpId > 0) {
            getLesseeInfo(project?.currentProject?.defaultOwnerLookUpId, true);
        }
    }, [project?.currentProject?.defaultOwnerLookUpId]);

    useEffect(() => {
        if (amendments.length > 0) {
            initializeAmendmentValues();
        }
    }, [amendments]);

    useEffect(() => {
        calcExpirationDate();
    }, [watchExpirationCalcFields]);

    useEffect(() => {
        updateTotalConsideration();
    }, [watchConsiderationAmount]);

    useEffect(() => {
        if (isRealOwnerAttach) {
            initializePage();
            setIsProvisional(false);
        }
    }, [isRealOwnerAttach]);

    useEffect(() => {
        updateTotalRent();
    }, [watchRentalFields]);

    useEffect(() => {
        if ((!appContext.leaseId && !!ownerData) || (!appContext.leaseId && ownerData?.tracts?.length < 1)) {
            reset(initialValuesNewLease());
            setFormLoading(false);
            if (ownerData.tracts?.length < 1) {
                setIsProvisional(true);
            } else {
                setIsProvisional(false);
            }
        }
    }, [ownerData]);

    useEffect(() => {
        if (!!leaseData) {
            addressRendering(ownerData?.tracts);
            setIsInhanded(leaseData?.isInHand);
            if (ownerData?.tracts?.length < 1) {
                setIsProvisional(true);
            }
        }
    }, [leaseData]);

    useEffect(() => {
        if (!!leaseData && leaseData.lesseeOwnerLookupId > 0) {
            getLesseeInfo(leaseData.lesseeOwnerLookupId, false);
        } else if (!!defaultLessee) {
            useDefaultLessee();
        }
    }, [leaseData, defaultLessee]);

    useEffect(() => {
        if (!!leaseData && !!states && !!defaultLessee && !!ownerData && !!contractClauses && !!appContext.leaseId) {
            reset(initialValues());
            setFormLoading(false);
        }
    }, [leaseData, states, defaultLessee, ownerData, contractClauses]);

    useEffect(() => {
        if (!!leaseData && !!contractClauses) {
            let currentSelection = [];
            for (let clause of leaseData.contractClauses) {
                currentSelection.push(contractClauses.indexOf(contractClauses.find(cc => cc.id === clause.contractAddendumClauseId)));
            }
            setSelectedClauses(currentSelection);
        }
    }, [leaseData, contractClauses]);

    useEffect(() => {
        if (appContext.leaseId > 0 && !!ownerData?.tracts && !!leaseData?.tracts && leaseData?.isInHand !== true && project.currentProject != null) {
            const hasChanges = AgreementUtil.findLeaseTractChanges(ownerData.tracts, leaseData.tracts, project?.currentProject?.landSystemId);
            if (hasChanges) {
                showTractListDeltaDialog();
            }
        }
    }, [project.currentProject, leaseData, ownerData, isProvisional]);

    useEffect(() => {
        if (!!tractState && !!counties) {
            tractLocationInfo();
        }
    }, [tractState, counties]);

    useEffect(() => {
        if (!isNaN(totalNet)) {
            updateTotalBonus();
            updateOptionTotalBonus();
        }
    }, [totalNet]);

    useEffect(() => {
        if (parentContractLookupId > 0) {
            refreshProvisions();
        }
    }, [parentContractLookupId]);

    useEffect(() => {
        let formValues = getValues();
        if (formValues.leasehold !== undefined && attachedProvisionClauses !== undefined) {
            formValues.leasehold.provisionLeaseClauses = initialProvisions(attachedProvisionClauses);
        }
        reset(formValues);
    }, [attachedProvisionClauses]);

    // useEffect(() => {
    //     if (!!leaseData && !!ownerData) {
    //         if (ownerData?.tracts.length !== leaseData?.tracts?.length) {
    //             setTimeout(() => {
    //                 if (
    //                     window.confirm(
    //                         `${leaseData?.ownersOnDocument} has been added to new Tracts after this contract was created. To use the most accurate data, please create a new contract!`
    //                     ) === true
    //                 ) {
    //                     manageTractDeviation();
    //                 }
    //             }, 2500);
    //         }
    //     }
    // }, [leaseData, ownerData]);

    const getContractClauses = async () => {
        const result = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/clauses/contract-clauses`);

        if (response.ok) {
            setContractClauses(result);
        } else {
            window.alert('get Lease Clauses call failed');
        }
    };

    const getLeaseClauseTypes = async () => {
        const result = await get(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/lease-clause-types`);

        if (response.ok) {
            setLeaseClauseTypes(result);
        } else {
            console.log('Unable to get Lease Clause Types');
        }
    };

    const getOwnerData = async () => {
        if (!isNaN(appContext.ownerId) && appContext.ownerId > 0) {
            const result = await get(
                `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leasegeneration/owner/${appContext.ownerId}`
            );

            if (response.ok) {
                setOwnerData(result);
            } else {
                window.alert('get Owner Data call failed');
            }
        }
    };

    const getLesseeInfo = async (ownerLookUpId: number, isDefaultLessee: boolean) => {
        const result = await get(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/${ownerLookUpId}`
        );

        if (response.ok) {
            if (isDefaultLessee === true) {
                setDefaultLessee(OwnerUtil.MapOwner(result));
            } else if (leaseData.isInHand !== true) {
                onOwnerSelected(result);
            }
            // } else {
            //     window.alert('get Default Lessee call failed');
        }
    };

    const getLeaseData = async (leaseId?: number) => {
        setLeaseData(null);
        setDeltasAdded(false);

        let leaseAddress = leaseId > 0 ? leaseId : appContext.leaseId;

        const result: Lease = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/${leaseAddress}`);

        if (response.ok) {
            handleUpdatedLease(result);
        } else {
            window.alert('getLeaseData call failed');
        }
    };

    const refreshProvisions = async () => {
        setAttachedProvisionClauses([]);

        const result: Array<ProvisionLeaseClause> = await get(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/provisionLeaseClause/agreements/${parentContractLookupId}`
        );

        if (response.ok) {
            setAttachedProvisionClauses(result);
        }
    };

    const getCalmsInfo = async (leaseNumber: string) => {
        const data = await get(`v1.0/calms/lease/${leaseNumber}`);

        if (response.ok) {
            setInvoiceData(data);
        } else {
            setInvoiceData(undefined);
        }

    };

    const getCalmsLeaseRecordInfo = async (calmsLeaseNumber: string) => {
        const data = await get(`v1.0/calms/lease/${calmsLeaseNumber}/lease-records`);

        if (response.ok) {
            try {
                const calmsData = JSON.parse(data.result);
                setLeaseRecordData(calmsData.items);
            } catch (e) {
                console.log('Error getting Calms info:', e);
                setLeaseRecordData(undefined);
            }
        }
    };

    const getAmendments = async () => {
        let result: Array<LeaseAmendment> = await get(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/${appContext.leaseId}/amendments`
        );

        if (response.ok) {
            setAmendments(result);
        }
    };

    const getStates = async () => {
        let result = await get('/v1.0/states');

        if (response.ok) {
            setTractStates(result);
        } else {
            console.log('Unable to get the States Data!!!');
        }
    };

    const getProjectContactCategories = async () => {
        let result = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/OwnershipContactCategories`);

        if (response.ok) {
            setProjectContactCategories(result);
        } else {
            console.log('Unable to get Project Contact Categories!!');
        }
    };

    const getAcknowledgementTypes = async () => {
        let result = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/contractGeneration/acknowledgement-types`);

        if (response.ok) {
            setAcknowledgementTypes(result);
        } else {
            console.log('Unable to get Acknowledgement Types');
        }
    };

    const getProvisionClauseTypes = async () => {
        const result: Array<ProvisionClauseType> = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/provisionLeaseClause/types/${LandContractType.OilAndGas}`);

        if (response.ok && Array.isArray(result)) {
            setProvisionClauseTypes(result ?? []);
        }
    };

    const createLease = async (data: Lease) => {
        const result = await post(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases`, data);
        const isBlankLease = appContext.ownerId === 0;
        if (response.ok) {
            dispatch(push(`../../../ownerId/${result.ownerId}/leases/${result.leaseId}`));
            if (isBlankLease) {
                window.location.reload();
            }
            setIsNewLease(false);
            handleSuccessfulSubmit(result.leaseId);
        } else if (result?.messageCode === '15') {
            window.alert('CALMS Update failed');
            setFormLoading(false);
        } else {
            window.alert('Create Lease failed');
            setFormLoading(false);
        }
    };

    const initialValuesNewLease = () => {
        const newLeaseData = new Lease();

        if (ownerData?.tracts?.length < 1) {
            newLeaseData.legalDescription = ' '.repeat(1001);
            setMoveLegalDescription(newLeaseData.legalDescription);
        }

        newLeaseData.id = 0;
        if (!!ownerData?.tracts) {
            newLeaseData.tracts = ownerData.tracts;
            setLeaseTractList(ownerData.tracts);
        }
        setLeaseData(newLeaseData);

        return newLeaseData;
    };

    const initialValues = () => {
        const initializedData = { ...leaseData };
        if (initializedData) {
            initializedData.effectiveDate = initializedData.effectiveDate
                ? (moment(initializedData.effectiveDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.leaseDate = initializedData.leaseDate
                ? (moment(initializedData.leaseDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.committedDate = initializedData.committedDate
                ? (moment(initializedData.committedDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.inHandDate = initializedData.inHandDate
                ? (moment(initializedData.inHandDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.originalInHandDate = initializedData.originalInHandDate
                ? (moment(initializedData.originalInHandDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.transferDate = initializedData.transferDate
                ? (moment(initializedData.transferDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.reminderDate = initializedData.reminderDate
                ? (moment(initializedData.reminderDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.topLeaseActiveDate = initializedData.topLeaseActiveDate
                ? (moment(initializedData.topLeaseActiveDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.topLeaseExpirationDate = initializedData.topLeaseExpirationDate
                ? (moment(initializedData.topLeaseExpirationDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            initializedData.recordedDate = initializedData.recordedDate
                ? (moment(initializedData.recordedDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
        }

        const currentLeasehold = leaseData?.leaseholds?.find((lh) => lh.mineralOwner?.ownerLookUpId === appContext.ownerId);

        if (currentLeasehold) {
            currentLeasehold.leaseDate = currentLeasehold.leaseDate
                ? (moment(currentLeasehold.leaseDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            currentLeasehold.effectiveDate = currentLeasehold.effectiveDate
                ? (moment(currentLeasehold.effectiveDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            currentLeasehold.expirationDate = currentLeasehold.expirationDate
                ? (moment(currentLeasehold.expirationDate).format('YYYY-MM-DD') as unknown as Date)
                : null;

            initializedData.leasehold = currentLeasehold;
            setParentContractLookupId(currentLeasehold.contractLookupId);
        }

        if (initializedData?.tracts?.length > 0 && initializedData && !!ownerData?.tracts) {
            let correctTracts: Array<ContractGenerationTractDetail> = [];

            ownerData?.tracts.forEach((t: ContractGenerationTractDetail) => {
                let match: ContractGenerationTractDetail = initializedData?.tracts.find((lt: ContractGenerationTractDetail) => lt.ownershipId === t.ownershipId);
                if (!!match) {
                    match.section = t.section;
                    match.sectionNumber = t.sectionNumber;
                    match.tractNumber = t.tractNumber;
                    match.surfaceTractNumber = t.surfaceTractNumber;
                    match.horizonNumber = t.horizonNumber;
                    correctTracts.push(match);
                } else {
                    correctTracts.push(t);
                }
            });

            initializedData.tracts = correctTracts.length > 0 ? correctTracts : leaseData.tracts;
            let acreages = AgreementUtil.calcTotalAcreages(initializedData.tracts, project?.currentProject?.landSystemId);

            setTotalGross(acreages[0]);
            isProvisional === true ? setTotalNet(initializedData?.leasehold?.provisionalNetAcres) : setTotalNet(acreages[1]);
            setLeaseTractList(initializedData.tracts);

        }

        if (initializedData?.tracts?.length > 0) {
            initializedData.rteLegalDescription = !!initializedData.rteLegalDescription ? initializedData.rteLegalDescription : AgreementUtil.formatTractListLegal(initializedData.tracts);
            initializedData.legalDescription = !!initializedData.legalDescription ? initializedData.legalDescription : AgreementUtil.convertToPlainText(initializedData.rteLegalDescription);
            initializedData.shortLegalDescription = !!initializedData.shortLegalDescription ? initializedData.shortLegalDescription : '';
            initializedData.bankingDays = !!initializedData.bankingDays ? initializedData.bankingDays : 0;
            initializedData.bankingDaysUnit = !!initializedData.bankingDaysUnit ? initializedData.bankingDaysUnit : '';
            setTractsSelected(!!initializedData.tracts.find(t => t.includeTract === true));
        }

        if (!!leaseData?.addConsiderationAmount && !!leaseData?.addConsiderationExplanation) {
            initializedData.isAddConsideration = true;
        }

        if (leaseData?.adHocClauses?.length > 0) {
            setAdHocClauses(leaseData.adHocClauses);
        }

        if (leaseData?.contractClauses?.length > 0) {
            initializedData.contractClauses = [];
            for (let i = 0; i < contractClauses.length; i++) {
                let clauseSelected = !!leaseData.contractClauses.find(cc => cc.contractAddendumClauseId === contractClauses[i].id);
                let addendumClauseId = clauseSelected ? contractClauses[i].id : 0;
                initializedData.contractClauses.push({ contractAddendumClauseId: addendumClauseId });
            }
        }

        if (ownerData?.tracts?.length < 1) {
            initializedData.legalDescription = 'TBD - Provisional Lease' + ' '.repeat(1001);
            setMoveLegalDescription(initializedData.legalDescription);
        }

        return initializedData;
    };

    const initialProvisions = (data: ProvisionLeaseClause[]) => {
        for (let i = 0; i < data.length; i++) {
            data[i].obligationDate = data[i].obligationDate
                ? (moment(data[i].obligationDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            data[i].obligationEndDate = data[i].obligationEndDate
                ? (moment(data[i].obligationEndDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
        }

        return data;
    };

    const calcExpirationDate = () => {
        const term = parseInt(watchExpirationCalcFields['leasehold.primaryTerm'] as string, 10);
        const termUnit = watchExpirationCalcFields['leasehold.primaryTermUnits'];
        const effectiveDate = new Date(watchExpirationCalcFields.effectiveDate as string);
        if (term && termUnit && !isNaN(effectiveDate.getTime())) {
            switch (termUnit) {
                case 'years':
                    setValue(
                        'leasehold.expirationDate',
                        new Date(effectiveDate.setFullYear(effectiveDate.getFullYear() + term)).toISOString().split('T')[0]
                    );
                    break;

                case 'months':
                    setValue(
                        'leasehold.expirationDate',
                        new Date(effectiveDate.setMonth(effectiveDate.getMonth() + term)).toISOString().split('T')[0]
                    );
                    break;

                case 'days':
                    setValue('leasehold.expirationDate', new Date(effectiveDate.setDate(effectiveDate.getDate() + term)).toISOString().split('T')[0]);
                    break;

                default:
                    break;
            }
        }
    };

    const onSubmit = (data: Lease) => {
        if (tractsSelected === true || appContext.ownerId === 0 || ownerData.tracts.length < 1) {
            setFormLoading(true);
            finalizeData(data);

            if (appContext.leaseId > 0) {
                updateLease(data);
            } else {
                data.id = 0;
                data.isGeneratedLease = true;
                createLease(data);
            }
        } else {
            window.alert('No Tract(s) Selected');
        }
    };

    const finalizeData = (data: Lease) => {
        let ownershipId = 0;

        data.id = appContext.leaseId;
        data.invoiceableLookupId = leaseData?.invoiceableLookupId != null ? leaseData.invoiceableLookupId : undefined;

        if (data.leaseAmendments?.length > 0) {
            data.leaseAmendments.forEach((amendment: LeaseAmendment) => {
                amendment.leaseId = appContext.leaseId;
                amendment.id = amendment.id ? parseInt(amendment.id + '', 10) : 0;
                amendment.createdByUserId = amendment.createdByUserId ? parseInt(amendment.createdByUserId + '', 10) : 0;

                amendment.amendmentType = amendment.amendmentType ? amendment.amendmentType : '';
                amendment.amendedField = amendment.amendedField ? amendment.amendedField : '';
                amendment.oldValue = amendment.oldValue ? amendment.oldValue : '';
                amendment.newValue = amendment.newValue ? amendment.newValue : '';
                amendment.book = amendment.book ? amendment.book : '';
                amendment.page = amendment.page ? amendment.page : '';
                amendment.instrumentNumber = amendment.instrumentNumber ? amendment.instrumentNumber : '';
                amendment.note = amendment.note ? amendment.note : '';

                amendment.isRecorded = amendment.isRecorded ? amendment.isRecorded : false;

                amendment.createdDate = amendment.createdDate ? (moment(amendment.createdDate).format('YYYY-MM-DD') as unknown as Date) : null;
                amendment.recordedDate = amendment.recordedDate ? (moment(amendment.recordedDate).format('YYYY-MM-DD') as unknown as Date) : null;

                if (amendment.id === 0 && amendment.amendedField.length > 0) {
                    (data)[amendment.amendedField] = amendment.newValue;
                }
            });
        }

        if (!isInHanded) {
            data.removeClauses = [];
    
            if (data.adHocClauses?.length > 0) {
                data.adHocClauses?.map((ahc, index) => {
                    ahc.id = ahc.id ? parseInt(ahc.id + '', 10) : 0;
                    ahc.leaseId = ahc.leaseId ? parseInt(ahc.leaseId + '', 10) : null;
                    ahc.contractLookupId = null;
                    ahc.leaseClauseTypeId = ahc.leaseClauseTypeId ? parseInt(ahc.leaseClauseTypeId + '', 10) : null;
                    ahc.leaseClauseType = leaseClauseTypes.find(lct => lct.id === ahc.leaseClauseTypeId)?.name ?? '';
                    ahc.clauseText = ahc.clauseText ? ahc.clauseText : '';
                });
                for (let clause of leaseData?.adHocClauses) {
                    if (data.adHocClauses?.indexOf(data.adHocClauses?.find(ahc => ahc.id === clause.id)) === -1) {
                        data.removeClauses.push(clause.id);
                    }
                }
            } else {
                data.removeClauses = leaseData?.adHocClauses?.length > 0 ? leaseData.adHocClauses.map(ahc => ahc.id) : [];
            }
    
            if (!!data.contractClauses) {
                let contractClause: Array<ContractAddendumClauseXRef> = data?.contractClauses?.map((cac: ContractAddendumClauseXRef, index: number) => {
                    let formatted = {
                        invoiceableLookupId: leaseData?.invoiceableLookupId > 0 ? parseInt(leaseData.invoiceableLookupId + '', 10) : 0,
                        contractAddendumClauseId: cac.contractAddendumClauseId ? parseInt(cac.contractAddendumClauseId + '', 10) : 0,
                        id: 0,
                    };
    
                    // tslint:disable-next-line: max-line-length
                    formatted.id =
                        leaseData?.contractClauses?.find(
                            (cc) =>
                                cc.invoiceableLookupId === formatted.invoiceableLookupId && cc.contractAddendumClauseId === formatted.contractAddendumClauseId
                        ) !== undefined
                            ? leaseData.contractClauses.find(
                                (cc) =>
                                    cc.invoiceableLookupId === formatted.invoiceableLookupId &&
                                    cc.contractAddendumClauseId === formatted.contractAddendumClauseId
                            ).id
                            : 0;
    
                    return formatted;
                });
    
                let filteredClause: Array<ContractAddendumClauseXRef> = contractClause.filter((lc) => lc.contractAddendumClauseId > 0);
                data.contractClauses = filteredClause;
            } else {
                data.contractClauses = [];
            }
        } else {
            data.contractClauses = leaseData.contractClauses ?? [];
            data.adHocClauses = leaseData.adHocClauses ?? [];
            for (let clause of data.adHocClauses) {
                clause.leaseClauseType = leaseClauseTypes.find(lct => lct.id === clause.leaseClauseTypeId)?.name ?? '';
            }
        }

        if (data.tracts?.filter(lt => lt.includeTract === true).length > 0) {
            ownershipId = data.tracts.filter(lt => lt.includeTract === true)[0].ownershipId;
            data.tracts.forEach((tract: ContractGenerationTractDetail) => {
                tract.id = tract.id ? parseInt(tract.id + '', 10) : 0;
                tract.tractNumber = tract.tractNumber ? parseInt(tract.tractNumber + '', 10) : 0;
                tract.surfaceTractNumber = tract.surfaceTractNumber ? parseInt(tract.surfaceTractNumber + '', 10) : 0;
                tract.contractLookupId = tract.contractLookupId ? parseInt(tract.contractLookupId + '', 10) : null;
                tract.invoiceableLookupId = tract.invoiceableLookupId ? parseInt(tract.invoiceableLookupId + '', 10) : null;
                tract.section = project?.currentProject?.landSystemId !== LandSystem.Eastern ? (tract.section ? parseInt(tract.section + '', 10) : 0) : 0;
                tract.range = project?.currentProject?.landSystemId !== LandSystem.Eastern ? (tract.range ? tract.range : '') : '';
                tract.sectionNumber = tract.sectionNumber ? parseInt(tract.sectionNumber + '', 10) : 0;
                tract.countyId = tract.countyId !== 0 && tract.countyId > 0 ? parseInt(tract.countyId + '', 10) : null;
                tract.grossAcres = tract.grossAcres ? parseFloat(tract.grossAcres + '') : 0;
                tract.horizonId = tract.horizonId ? parseInt(tract.horizonId + '', 10) : null;
                tract.horizonNumber = tract.horizonNumber ? parseInt(tract.horizonNumber + '', 10) : 0;
                tract.decimalInterest = tract.decimalInterest ? parseFloat(tract.decimalInterest + '') : 0;
                tract.includeTract = tract.includeTract ? true : false;
                tract.ownershipId = tract.ownershipId ? parseInt(tract.ownershipId + '', 10) : 0;
                tract.leaseId = tract.leaseId ? parseInt(tract.leaseId + '', 10) : 0;
                tract.netAcres = tract.netAcres ? parseFloat(tract.netAcres + '') : 0;
                tract.hasNEMI = tract.hasNEMI ? true : false;
                tract.type = tract.type ? tract.type : '';
                tract.county = !!tract.county ? tract.county : null;
                tract.township = tract.township;
                tract.rowLineName = tract.rowLineName;
            });
        }

        if (data.leasehold) {
            const originalLeasehold = leaseData?.leaseholds?.find((lh) => lh.mineralOwner?.ownerLookUpId === appContext.ownerId);

            const swapOwnerId = data.leaseholds?.[0].ownershipId;
            data.leaseholds = leaseData?.leaseholds;
            let currentLeasehold = leaseData?.leaseholds?.find((lh) => lh.mineralOwner?.ownerLookUpId === appContext.ownerId);
            if (currentLeasehold === undefined && leaseData?.leaseholds?.length === 1) {
                currentLeasehold = leaseData?.leaseholds?.[0];
                currentLeasehold.mineralOwner = ownerData.ownerDetails;
                data.leaseholds[0].mineralOwner = ownerData.ownerDetails;
            }

            if (ownerData?.tracts?.length < 1 && ownerData.ownerships.length === 1) {
                data.leasehold.ownershipId = ownerData.ownerships[0].id;
                data.leasehold.leaseId = leaseData?.id;
            }

            if (swapOwnerId) {
                data.leaseholds = [];
                data.leaseholds.push(new Leasehold());
                data.leaseholds[0].ownershipId = 0;
                data.leasehold.ownershipId = 0;
                data.leasehold.mineralOwner = { ownerLookUpId: swapOwnerId } as IOwner;
            }

            data.leasehold.id = currentLeasehold?.id !== undefined ? currentLeasehold?.id : 0;
            if (!(appContext.leaseId > 0)) {
                data.leasehold.id = 0;
            }
            data.leasehold.effectiveDate = data.leasehold.effectiveDate
                ? (moment(data.leasehold.effectiveDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            data.leasehold.expirationDate = data.leasehold.expirationDate
                ? (moment(data.leasehold.expirationDate).format('YYYY-MM-DD') as unknown as Date)
                : null;
            data.leasehold.leaseDate = data.leasehold.leaseDate ? (moment(data.leasehold.leaseDate).format('YYYY-MM-DD') as unknown as Date) : null;

            data.leasehold.royalty = data.leasehold.royalty ? parseFloat(data.leasehold.royalty + '') : null;
            data.leasehold.optionTerm = data.leasehold.optionTerm ? parseInt(data.leasehold.optionTerm + '', 10) : 0;
            data.leasehold.recordTypeId = data.leasehold.recordTypeId ? parseInt(data.leasehold.recordTypeId + '', 10) : 0;
            data.leasehold.rentalprice = data.leasehold.rentalprice ? parseFloat(data.leasehold.rentalprice + '') : 0;
            data.leasehold.priceTypeId = data.leasehold.priceTypeId ? parseInt(data.leasehold.priceTypeId + '', 10) : 0;
            data.leasehold.apiNumber = data.leasehold.apiNumber ? data.leasehold.apiNumber : null;
            data.leasehold.totalBonus = data.leasehold.totalBonus ? parseFloat(data.leasehold.totalBonus + '') : 0;
            data.leasehold.bonusPerAcre = data.leasehold.bonusPerAcre ? parseFloat(data.leasehold.bonusPerAcre + '') : 0;
            data.leasehold.optionPerAcre = data.leasehold.optionPerAcre ? parseFloat(data.leasehold.optionPerAcre + '') : 0;
            data.leasehold.primaryTerm = data.leasehold.primaryTerm ? parseInt(data.leasehold.primaryTerm + '', 10) : 0;

            data.leasehold.ownershipId = data.leasehold.ownershipId ? parseInt(data.leasehold.ownershipId + '', 10) : parseInt(ownershipId + '', 10);

            data.leasehold.optionExercised = data.leasehold.optionExercised ? parseBool(data.leasehold.optionExercised + '') : null;

            data.leasehold.optionBonusAmount = data.leasehold.optionBonusAmount ? parseFloat(data.leasehold.optionBonusAmount + '') : 0;
            data.leasehold.optionTotalBonus = data.leasehold.optionTotalBonus ? parseFloat(data.leasehold.optionTotalBonus + '') : 0;
            data.leasehold.isTopLease = !newLeaseType ? false : newLeaseType === '2' ? true : false;
            data.leasehold.isActiveLease = !data.leasehold?.isTopLease;
            data.leasehold.provisionalGrossAcres = data.leasehold?.provisionalGrossAcres ? parseInt(data.leasehold?.provisionalGrossAcres + '', 10) : null;
            data.leasehold.provisionalNetAcres = data.leasehold?.provisionalNetAcres ? parseInt(data.leasehold?.provisionalNetAcres + '', 10) : null;

            if (isInHanded && data.leasehold.provisionLeaseClauses?.length > 0) {
                data.leasehold.provisionLeaseClauses = data.leasehold.provisionLeaseClauses.map((plc) => {
                    plc.contractLookupId = plc.contractLookupId ? parseInt(plc.contractLookupId + '', 10) : null;
                    plc.id = plc.id ? parseInt(plc.id + '', 10) : 0;
                    plc.leaseAdHocClauseId = plc.leaseAdHocClauseId ? parseInt(plc.leaseAdHocClauseId + '', 10) : null;
                    plc.contractAdHocClauseId = plc.contractAdHocClauseId ? parseInt(plc.contractAdHocClauseId + '', 10) : null;
                    plc.contractAddendumClauseId = plc.contractAddendumClauseId ? parseInt(plc.contractAddendumClauseId + '', 10) : null;
                    plc.clauseTypeId = plc.clauseTypeId ? parseInt(plc.clauseTypeId + '', 10) : null;
                    plc.frequency = plc.frequency ? parseInt(plc.frequency + '', 10) : null;

                    plc.useClientApproved = plc.useClientApproved ? AgreementUtil.parseBool(plc.useClientApproved + '') : null;

                    plc.obligationDate = plc.obligationDate ? (moment(plc.obligationDate).format('YYYY-MM-DD') as unknown as Date) : null;
                    plc.obligationEndDate = plc.obligationEndDate ? (moment(plc.obligationEndDate).format('YYYY-MM-DD') as unknown as Date) : null;

                    return plc;
                });
            } else {
                data.leasehold.provisionLeaseClauses = attachedProvisionClauses ?? [];
            }
            data.leasehold.leaseholdClause = originalLeasehold?.leaseholdClause ?? new LeaseholdClauses();
        }
        data.legalDescription = data.rteLegalDescription ? AgreementUtil.convertToPlainText(data.rteLegalDescription) : data.legalDescription;

        data.effectiveDate = data.effectiveDate ? (moment(data.effectiveDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.leaseDate = data.leaseDate ? (moment(data.leaseDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.committedDate = data?.committedDate ? (moment(data.committedDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.inHandDate = data.inHandDate ? (moment(data.inHandDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.originalInHandDate = data.originalInHandDate ? (moment(data.originalInHandDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.transferDate = data.transferDate ? (moment(data.transferDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.reminderDate = data.reminderDate ? (moment(data.reminderDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.recordedDate = data.recordedDate ? (moment(data.recordedDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.topLeaseActiveDate = data.topLeaseActiveDate ? (moment(data.topLeaseActiveDate).format('YYYY-MM-DD') as unknown as Date) : null;
        data.topLeaseExpirationDate = data.topLeaseExpirationDate
            ? (moment(data.topLeaseExpirationDate).format('YYYY-MM-DD') as unknown as Date)
            : null;
        data.rentalDueDate = data.rentalDueDate ? (moment(data.rentalDueDate).format('YYYY-MM-DD') as unknown as Date) : null;

        data.isCommitted = (data.isCommitted !== leaseData.isCommitted && data.isCommitted !== undefined) ? !leaseData.isCommitted : leaseData.isCommitted;
        data.isInHand = (data.isInHand !== leaseData.isInHand && data.isInHand !== undefined) ? !leaseData.isInHand : leaseData.isInHand;
        data.isTransfer = (data.isTransfer !== leaseData.isTransfer && data.isTransfer !== undefined) ? !leaseData.isTransfer : leaseData.isTransfer;
        data.isFiledByMemo = (data.isFiledByMemo !== leaseData.isFiledByMemo && data.isFiledByMemo !== undefined) ? !leaseData.isFiledByMemo : leaseData.isFiledByMemo;
        // set isRentalLease based on newLease value
        data.isRentalLease = !newLeaseType ? false : newLeaseType === '3';
        data.isTopLease = !newLeaseType ? false : newLeaseType === '2';
        data.isOptionToExtend = data.isOptionToExtend ? true : false;
        data.isAddOptionToExtend = data.isAddOptionToExtend ? true : false;
        data.isNotOriginalLessee = data.isNotOriginalLessee ? true : false;
        data.isVoid = data.isVoid ? data.isVoid : false;

        // TODO: Consider a better solution than defaulting to this lessee if there's no data.
        data.lesseeOwnerLookupId = data.lesseeOwnerLookupId ? parseInt(data.lesseeOwnerLookupId + '', 10) : defaultLessee?.ownerLookUpId;

        data.rentalAmount = data.rentalAmount ? parseFloat(data.rentalAmount + '') : null;
        data.recordTypeId = data.recordTypeId ? parseInt(data.recordTypeId + '', 10) : null;
        data.rentalPrice = data.rentalPrice ? parseFloat(data.rentalPrice + '') : null;
        data.originalGross = data.originalGross ? parseFloat(data.originalGross + '') : null;
        data.rentalPriceTypeId = data.rentalPriceTypeId ? parseInt(data.rentalPriceTypeId + '', 10) : null;
        data.rentalTotalRent = data.rentalTotalRent ? parseFloat(data.rentalTotalRent + '') : null;
        data.topLeasePercentDown = data.topLeasePercentDown ? parseFloat(data.topLeasePercentDown + '') : null;
        data.topLeaseAmount = data.topLeaseAmount ? parseFloat(data.topLeaseAmount + '') : null;
        data.topLeaseRemainingBalance = data.topLeaseRemainingBalance ? parseFloat(data.topLeaseRemainingBalance + '') : null;
        data.topLeaseDraftDays = data.topLeaseDraftDays ? parseInt(data.topLeaseDraftDays + '', 10) : null;
        data.primaryTerm = data.primaryTerm ? parseInt(data.primaryTerm + '', 10) : null;
        data.bonusAmount = data.bonusAmount ? parseFloat(data.bonusAmount + '') : null;
        data.totalBonus = data.totalBonus ? parseFloat(data.totalBonus + '') : null;
        data.optionBonusAmount = data.optionBonusAmount ? parseFloat(data.optionBonusAmount + '') : null;
        data.addOptionTotalBonus = data.addOptionTotalBonus ? parseFloat(data.addOptionTotalBonus + '') : null;
        data.addOptionBonusAmount = data.addOptionBonusAmount ? parseFloat(data.addOptionBonusAmount + '') : null;
        data.addOptionTerm = data.addOptionTerm ? parseInt(data.addOptionTerm + '', 10) : null;
        data.addConsiderationAmount = data.addConsiderationAmount ? parseFloat(data.addConsiderationAmount + '') : null;
        data.totalConsideration = data.totalConsideration ? parseFloat(data.totalConsideration + '') : null;
        data.optionTotalBonus = data.optionTotalBonus ? parseFloat(data.optionTotalBonus + '') : null;
        data.isGeneratedLease = true;

        data.originalGross = totalGross ? totalGross : 0;
        data.shortLegalDescription = data.shortLegalDescription ? data.shortLegalDescription : '';
        data.bankingDays = data.bankingDays ? parseInt(data.bankingDays + '', 10) : null;
        data.bankingDaysUnit = data.bankingDaysUnit ? data.bankingDaysUnit : null;

        return data;
    };

    const handleSuccessfulSubmit = (id: number, updatedLease: Lease = null) => {
        getContractClauses();
        getProvisionClauseTypes();
        setOriginalTractList([]);
        if (appContext.ownerId > 0) {
            setOwnerData(undefined);
            getOwnerData();
        }
        if (updatedLease !== null) {
            setLeaseData(null);
            setDeltasAdded(false);
            handleUpdatedLease(updatedLease);
        } else {
            getLeaseData(id);
        }
    };

    const handleUpdatedLease = (lease: Lease) => {
        const currentLeasehold = lease?.leaseholds?.find((lh: Leasehold) => lh.mineralOwner?.ownerLookUpId === appContext.ownerId);
        lease.leasehold = currentLeasehold;
        setLeaseData(lease);
        getCalmsLeaseRecordInfo(lease.leaseNumber);
        getCalmsInfo(lease.leaseNumber);
    };

    const updateLease = async (data: Lease) => {
        const wasInHand = leaseData?.isInHand === true;
        const isNowInHand = data.isInHand === true;
        const isRevokingInHand = data.isInHand === false && wasInHand;
        const needsCalms = (isNowInHand || isRevokingInHand) && data.tracts?.length > 0;
        // Endpoint for Generated Lease
        await put(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/${appContext.leaseId}/true`, data);

        if (!response.ok) {
            window.alert('Unable to Update Lease');
            setFormLoading(false);
            return;
        }

        const updatedLease: Lease = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/${appContext.leaseId}`);
        let attachedIds = data.leasehold.provisionLeaseClauses.map(plc => plc.id);

        const provisionDto: ProvisioningUpdateDto = {
            provisionLeaseClauses: data.leasehold.provisionLeaseClauses,
            provisionDeletes: attachedProvisionClauses.map(ap => ap.id).filter(ap => attachedIds.indexOf(ap) === -1),
            contractLookupIds: updatedLease?.tracts?.map(ul => ul.contractLookupId).filter(cl => cl > 0)
        };

        await put(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/provisionLeaseClause`, provisionDto)
        .then(() => {
            setIsInhanded(isNowInHand);
            logContractInformation(data);

            let cLeasehold = updatedLease?.leaseholds?.find((lh) => lh.mineralOwner?.ownerLookUpId === appContext.ownerId);
            if (cLeasehold != null) {
                cLeasehold.provisionLeaseClauses = data.leasehold.provisionLeaseClauses;
                setParentContractLookupId(0);
            }
            handleSuccessfulSubmit(appContext.leaseId, updatedLease);
    
            if (needsCalms) {
                submitToCalms(appContext.leaseId, isNowInHand);
            }
        })
        .catch((error) => {
            window.alert('Could not update Provisions!');
            console.log('Provision Update Error:', error);
            setFormLoading(false);
        });
    };
  
    const submitToCalms = async (leaseId: number, wasInHandAction: boolean) => {
        setCalmsSubmitting(true);
        try {
            await post(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/${leaseId}/submit-to-calms`);

            if (response.ok) {
                setCalmsSubmitting(false);
            } else {
                setCalmsSubmitting(false);
                if (wasInHandAction) {
                    window.alert('Oracle submission failed. The In-Hand status will be reverted.');
                    onRevokeInHand();
                } else {
                    window.alert('Oracle update failed. The lease has been revoked locally but Oracle may not reflect this change. Please contact support or retry.');
                    getLeaseData(leaseId);
                }
            }
        } catch (err) {
            setCalmsSubmitting(false);
            if (wasInHandAction) {
                window.alert('Oracle submission failed. The In-Hand status will be reverted.');
                onRevokeInHand();
            } else {
                window.alert('Oracle update failed. Please contact support or retry.');
                getLeaseData(leaseId);
            }
        }
    };

    // const updateOwnerInfo = async (data: Lease) => {
    //     let leaseInfo: Lease = data;
    //     let ownerInfo: LeaseGenerationOwnerData = ownerData;

    //     ownerInfo.tracts = leaseInfo.tracts;

    //     const result = await put(
    //         `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leaseGeneration/owner/${ownerInfo?.ownerDetails?.ownerLookUpId}`,
    //         ownerInfo
    //     );

    //     if (response.ok) {
    //         handleSuccesfulSubmit(appContext.leaseId);
    //     } else {
    //     }
    // };

    const parseBool = (value: string) => {
        if (value === 'true') {
            return true;
        } else if (value === 'false') {
            return false;
        }
        return null;
    };

    const showLPRPDFDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.LPR_VIEWER));
    };

    const showLeasePDFDialog = async (id: number) => {
        // TODO: Remove conditional when Aethon Leases are implemented via mail merge.
        if (id === 2) {
            // setPDFFormValues({});
            setRenderTemplate(id);
            dispatch(actions.layout.showDialog(DialogList.PDF_WINDOW));
        } else {
            console.log('Id', id);

            const result = await post(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/documentTemplate/${appContext.leaseId}/merge/${id}`);

            if (response.ok) {
                // window.alert('Document Generated Successfully');

                await response.blob().then((blob) => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.getElementById(`a_mergedDoc`) as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = 'Lease';
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            } else {
                console.log('Unable to generate document.', result);
            }
        }
    };

    const showMemoPDFDialog = async (id: number) => {
        // TODO: Remove conditional when Aethon Leases are implemented via mail merge.
        if (id === 3) {
            setRenderMemo(id);
            dispatch(actions.layout.showDialog(DialogList.MEMO_VIEWER));
        } else {
            const result = await post(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/documentTemplate/${appContext.leaseId}/merge/${id}`);

            if (response.ok) {
                // window.alert('Document Generated Successfully');

                await response.blob().then((blob) => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.getElementById(`a_mergedDoc`) as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = 'Memo';
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            } else {
                console.log('Unable to generate document.', result);
            }
        }
    };

    const showOopPDFDialog = async (id: number) => {
        // TODO: Remove conditional when Aethon Leases are implemented via mail merge.
        if (id === 1) {
            setRenderOOP(id);
            dispatch(actions.layout.showDialog(DialogList.OOP_VIEWER));
        } else {
            const result = await post(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/documentTemplate/${appContext.leaseId}/merge/${id}`);

            if (response.ok) {
                // window.alert('Document Generated Successfully');

                await response.blob().then((blob) => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.getElementById(`a_mergedDoc`) as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = 'Order Of Payment';
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            } else {
                console.log('Unable to generate document.', result);
            }
        }

    };

    const refreshTractMORs = () => {
        let files = new Array<ReportFileDetails>();
        let tractList = leaseData?.tracts?.length > 0 ? leaseData.tracts.filter(tr => tr.includeTract === true) : [];
        for (let x = 0; x < tractList?.length; x++) {
            // tslint:disable-next-line:max-line-length
            let globalId = appContext.clientNumber + `.` + appContext.projectNumber + `.` + tractList[x].sectionNumber + `.` + tractList[x].tractNumber + `-` + tractList[x].horizonNumber;
            let tractType = tractList[x].type.toLowerCase().search('surface') > 0 ? 'Surface Tract' : 'Mineral Tract';
            files.push({ reportFileType: Constants.refreshMORReportFileType, tractType: tractType, globalId: globalId });
        }
        setTractMORList(files);
    };

    const onCommit = (data: boolean) => {
        if (!!data) {
            let formData: AnyObject = getValues();
            formData.committedDate = new Date().toISOString().split('T')[0];
            formData.isCommitted = true;
            leaseData.isCommitted = true;
            leaseData.committedDate = new Date();
            onSubmit(formData as Lease);
        }
    };

    const onDecommit = () => {
        let formData: AnyObject = getValues();
        formData.committedDate = undefined;
        formData.isCommitted = false;
        onSubmit(formData as Lease);
        hideDialog();
    };

    const updateProcessing = (current: number, selection: Array<number>) => {
        setSelectedClauses(selection);

        let currentContract = contractClauses[current];
        let formString = 'leasehold.leaseholdClause.';
        let isSelected = selection.includes(current);
        let description = isSelected ? currentContract.clauseText : '';

        switch (currentContract.leaseClauseType) {
            case 'Pugh':
                formString += 'pugh';
                break;
            case 'Depth Pugh':
                formString += 'depthPugh';
                break;
            case 'Depth Exclusion':
                formString += 'depthExclusion';
                break;
            case 'Continuing Development':
                formString += 'continuingDevelopment';
                break;
            case 'Shutin':
                formString += 'shutin';
                break;
            case 'Surface Restriction':
                formString += 'surfaceRestriction';
                break;
            case 'Favored Nation':
                formString += 'favoredNation';
                break;
            case 'Non-Drilling':
                formString += 'nonDrilling';
                break;
            case 'Top Lease Language':
                formString += 'topLease';
                break;
            case 'Net Proceeds Lease':
                formString += 'netProceedsLease';
                break;
            case 'Cost Free Royalty':
                formString += 'costFreeRoyalty';
                break;
            case 'Other':
                formString += 'other';
                break;
            default:
                return;
        }

        setValue(formString, isSelected);
        setValue(formString + 'Description', description);
    };

    const hideDialog = () => {
        dialogContext.hideDialog();
    };

    const showStatusDialog = () => {
        dialogContext.contract.selectContractCommittedStatus(projectContactCategories, ownerData, leaseData, onCommit, hideDialog);
    };

    const showUncommitConfirmationDialog = () => {
        dialogContext.contract.deCommitContract(leaseData?.leaseNumber, ownerData, leaseData, hideDialog, onDecommit, hideDialog);
    };

    const showTractListDeltaDialog = () => {
        let oTracts = [...ownerData.tracts];

        for (let t of oTracts) {
            if (!!t.easternTownship) {
                t.township = t.easternTownship;
            }
        }

        dialogContext.owners.tractListDeltaDialog(
            (ownerData.tracts.length > 0 && leaseData?.tracts?.length === 0),
            project?.currentProject?.landSystemId === LandSystem.Eastern,
            ownerData.tracts,
            leaseData.tracts,
            onDeltaUpdate
        );
    };

    const logContractInformation = (updateData: IContract) => {
        let contractTuple: { item1: IContract, item2: IContract };
        contractTuple = { item1: leaseData, item2: updateData };
        let logBody = JSON.stringify(contractTuple);

        post(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/${controllerPath}/modification-log`, logBody);

        // if (response.ok) {
        //     console.log('Agreement Logging, model binding success');
        // }
    };

    const showConfirmRevokeInhandDialog = () => {
        dialogContext.contract.revokeInhandContractStatus(LandContractType.OilAndGas, leaseData?.leaseNumber, hideDialog, onRevokeInHand, hideDialog);
    };

    const showAttachOwnerDialog = () => {
        openOwnerDialog();
    };

    const onDeltaUpdate = () => {
        if (isInHanded !== true) {
            setOriginalTractList(leaseData.tracts);
            let newData = { ...leaseData };
            newData.tracts = [...ownerData.tracts];
            let availabilityCheck = false;
            for (let tract of newData.tracts) {
                let cLease = leaseData.tracts.find(lt => lt.ownershipId === tract.ownershipId);
                tract.includeTract = (cLease?.includeTract ?? false) && tract.leasedStatus !== 'Leased';
                availabilityCheck = availabilityCheck || tract.leasedStatus !== 'Leased';
                tract.id = !!cLease ? cLease.id : null;
            }
            if (!availabilityCheck) {
                window.alert('There are no selectable tracts remaining. Agreement should be voided.');
            }
            setLeaseData(newData);
            setDeltasAdded(true);
            setTractsSelected(!!newData.tracts.find(tl => tl.includeTract === true));
        }
    };

    const onInHand = () => {
        let formData: AnyObject = getValues();
        if (!(formData.ownersAddressOnDocument?.length > 0 && formData.ownersOnDocument)) {
            window.alert('Owner Information required for In-Handing!');
        } else if (!(formData.lesseeOwnerLookupId > 0)) {
            window.alert('Default Lessee Info required for In-Handing!');
        } else {
            formData.inHandDate = new Date().toISOString().split('T')[0];
            formData.isInHand = true;
            if (!formData.originalInHandDate || formData.originalInHandDate === '') {
                formData.originalInHandDate = new Date().toISOString().split('T')[0];
            }
            if (formData?.tracts?.length > 0) {
                formData?.tracts?.forEach((t: ContractGenerationTractDetail) => {
                    if (t.includeTract === true) {
                        t.leasedStatus = 'Leased';
                    }
                });
            }
            onSubmit(formData as Lease);
        }
    };

    const onRevokeInHand = () => {
        let formData: AnyObject = getValues();
        formData.inHandDate = null;
        formData.isInHand = false;
        if (formData?.tracts?.length > 0) {
            formData?.tracts?.forEach((t: ContractGenerationTractDetail) => {
                if (t.includeTract === true) {
                    t.leasedStatus = 'Open';
                }
            });
        }
        onSubmit(formData as Lease);
    };

    // const onTransfer = () => {
    //     setValue('transferDate', new Date().toISOString().split('T')[0]);
    // };

    const displayOwnerDetails = () => {
        if (ownerData?.ownerDetails) {
            const ownerDetails = OwnerUtil.MapOwner(ownerData.ownerDetails);

            if (ownerDetails instanceof OwnerJointTenant) {
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: 'auto 2rem' }}>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Name:</span>
                            <span style={{ color: '#6393c1' }}>{ownerDetails?.ownerName()}</span>
                        </div>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Address:</span>
                            <div>
                                <span style={{ color: '#6393c1' }}>{!!ownerDetails?.addressLine1 ? ownerDetails?.addressLine1 + ', ' : ''}</span>
                                <span style={{ color: '#6393c1' }}>{!!ownerDetails?.addressLine2 ? ownerDetails?.addressLine2 + ', ' : ''}</span>
                                <span style={{ color: '#6393c1' }}>{!!ownerDetails?.city ? ownerDetails?.city + ', ' : ''}</span>
                                <span style={{ color: '#6393c1' }}>{!!ownerDetails?.state ? ownerDetails?.state + ', ' : ''}</span>
                                <span style={{ color: '#6393c1' }}>{ownerDetails?.zipCode}</span>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Email:</span>
                            <span style={{ color: '#6393c1' }}>{ownerDetails.email || 'No Email'}</span>
                        </div>
                    </div>
                );
            } else if (ownerDetails instanceof OwnerIndividual) {
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: 'auto 2rem' }}>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Name:</span>
                            <span style={{ color: '#6393c1' }}>
                                {`${ownerDetails?.firstName}${!!ownerDetails?.middleName ? ` ${ownerDetails?.middleName} ` : ' '}${ownerDetails?.lastName
                                    }`}
                            </span>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Spouse Name:</span>
                            {ownerDetails?.spouseFirstName && ownerDetails?.spouseFirstName?.length > 0 && <span style={{ color: '#6393c1' }}>
                                {`${ownerDetails?.spouseFirstName}${!!ownerDetails?.spouseMiddleName ? ` ${ownerDetails?.spouseMiddleName} ` : ' '}${ownerDetails?.spouseLastName
                                    }`}
                            </span>}
                        </div>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Address:</span>
                            <div>
                                <span style={{ color: '#6393c1' }}>
                                    {!!ownerDetails?.address?.addressLine1 ? ownerDetails?.address?.addressLine1 + ', ' : ''}
                                </span>
                                <span style={{ color: '#6393c1' }}>
                                    {!!ownerDetails?.address?.addressLine2 ? ownerDetails?.address?.addressLine2 + ', ' : ''}
                                </span>
                                <span style={{ color: '#6393c1' }}>{!!ownerDetails?.address?.city ? ownerDetails?.address?.city + ', ' : ''}</span>
                                <span style={{ color: '#6393c1' }}>
                                    {!!ownerDetails.address?.state?.name ? ownerDetails.address?.state?.name + ', ' : ''}
                                </span>
                                <span style={{ color: '#6393c1' }}>{ownerDetails.address?.zipCode}</span>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Email:</span>
                            <span style={{ color: '#6393c1' }}>{ownerDetails.email || 'No Email'}</span>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: 'auto 2rem' }}>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Name:</span>
                            <span style={{ color: '#6393c1' }}>{ownerDetails?.ownerName()}</span>
                        </div>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Address:</span>
                            <div>
                                <span style={{ color: '#6393c1' }}>
                                    {!!ownerDetails?.address?.addressLine1 ? ownerDetails?.address?.addressLine1 + ', ' : ''}
                                </span>
                                <span style={{ color: '#6393c1' }}>
                                    {!!ownerDetails?.address?.addressLine2 ? ownerDetails?.address?.addressLine2 + ', ' : ''}
                                </span>
                                <span style={{ color: '#6393c1' }}>{!!ownerDetails?.address?.city ? ownerDetails?.address?.city + ', ' : ''}</span>
                                <span style={{ color: '#6393c1' }}>
                                    {!!ownerDetails.address?.state?.name ? ownerDetails.address?.state?.name + ', ' : ''}
                                </span>
                                <span style={{ color: '#6393c1' }}>{ownerDetails.address?.zipCode}</span>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <span style={{ fontSize: 'medium', fontWeight: 'bold' }}>Email:</span>
                            <span style={{ color: '#6393c1' }}>{ownerDetails.email || 'No Email'}</span>
                        </div>
                    </div>
                );
            }
        } else {
            return <div>No Owner Data</div>;
        }
    };

    const updateOwnerData = () => {
        if (!!ownerData?.ownerDetails) {
            const ownerInfo = OwnerUtil.MapOwner(ownerData.ownerDetails);
            setValue('ownersOnDocument', ownerInfo.ownerName());
            setValue('ownersSSNTaxIdOnDocument', ownerInfo.ssnTaxId);
            if (ownerInfo instanceof OwnerJointTenant) {
                setValue('ownersOnDocument', ownerInfo.ownerName());
                setValue(
                    'ownersAddressOnDocument',
                    `${ownerInfo?.addressLine1 ? ownerInfo?.addressLine1 + ', ' : ''}${ownerInfo?.city ? ownerInfo?.city + ', ' : ''}${ownerInfo?.state ? ownerInfo?.state + ' ' : ''
                    }${ownerInfo?.zipCode ? ownerInfo?.zipCode : ''}`
                );
            } else if (ownerInfo instanceof OwnerIndividual) {
                setValue(
                    'ownersOnDocument',
                    `${ownerInfo?.firstName}${ownerInfo?.middleName ? ` ${ownerInfo?.middleName} ` : ' '}${ownerInfo?.lastName}`
                );
                setValue(
                    'ownersAddressOnDocument',
                    `${ownerInfo.address?.addressLine1 ? ownerInfo.address?.addressLine1 + ', ' : ''}${ownerInfo.address?.city ? ownerInfo.address?.city + ', ' : ''
                    }${ownerInfo.address?.state?.name ? ownerInfo.address?.state?.name + ' ' : ''}${ownerInfo.address?.zipCode ? ownerInfo.address?.zipCode : ''
                    }`
                );
            } else {
                setValue('ownersOnDocument', ownerInfo.ownerName());
                setValue(
                    'ownersAddressOnDocument',
                    `${ownerInfo.address?.addressLine1 ? ownerInfo.address?.addressLine1 + ', ' : ''}${ownerInfo.address?.city ? ownerInfo.address?.city + ', ' : ''
                    }${ownerInfo.address?.state?.name ? ownerInfo.address?.state?.name + ' ' : ''}${ownerInfo.address?.zipCode ? ownerInfo.address?.zipCode : ''
                    }`
                );
            }
        }
    };

    const updateLegalDescription = () => {
        let tractList: Array<ContractGenerationTractDetail> = getValues().tracts;
        console.log('Tract List for Legal Description Update:', tractList);

        if (!!tractList) {
            let legal = AgreementUtil.formatTractListLegal(tractList);
            let shortLegal = AgreementUtil.formatShortLegalDescription(tractList, ownerData?.ownerships, ownerData?.ownerDetails);
            setValue('rteLegalDescription', legal);
            setValue('shortLegalDescription', shortLegal);
            setMoveLegalDescription(legal);
            setDeltasAdded(true);

            if (isProvisional === true) {
                setTotalGross(leaseData?.leasehold?.provisionalGrossAcres);
                setTotalNet(leaseData?.leasehold?.provisionalNetAcres);
            } else {
                let acreages = AgreementUtil.calcTotalAcreages(tractList, project?.currentProject?.landSystemId);
                setTotalGross(acreages[0]);
                setTotalNet(acreages[1]);
            }

            setTractsSelected(!!tractList.find(tl => tl.includeTract === true));
        } else {
            console.log('Error getting tract list form:', getValues());
        }
    };

    const useDefaultLessee = () => {
        if (defaultLessee) {
            setValue('lesseeName', defaultLessee.ownerName());
            setValue('lesseeAddressLine1', defaultLessee.address?.addressLine1);
            setValue('lesseeAddressLine2', defaultLessee.address?.addressLine2);
            setValue('lesseeCity', defaultLessee.address?.city);
            setValue('lesseeState', defaultLessee.address?.state?.name);
            setValue('lesseeZipCode', defaultLessee.address?.zipCode);
            setValue('lesseeOwnerLookupId', defaultLessee.ownerLookUpId);
            if (!!defaultLessee.phoneNumberChanges?.phoneNumbers?.find(pn => pn.isPrimary === true)) {
                setValue('lesseePhoneNumber', defaultLessee.phoneNumberChanges?.phoneNumbers?.find(pn => pn.isPrimary === true).number);
            } else if (defaultLessee.phoneNumberChanges?.phoneNumbers?.length > 0) {
                setValue('lesseePhoneNumber', defaultLessee.phoneNumberChanges?.phoneNumbers[0].number);
            } else {
                setValue('lesseePhoneNumber', '');
            }
        } else {
            window.alert('Default Lessee is not available. Either create a new owner or contact your PM.');
        }
    };

    const UpdateOwnership = async (ownershipId: number, ownerLookupId: number) => {
        if (ownershipId > 0 && ownerLookupId > 0) {
            await put(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/ownership/${ownershipId}/previousOwnership/${ownerData?.ownerships[0].id}/ownerLookup/${ownerLookupId}`);

            if (response.ok) {
                return true;
            }
        }
        return false;
    };

    const onRealOwnerSelected = (owner: IOwner) => {
        if (owner?.ownerLookUpId !== undefined) {
            if (UpdateOwnership(ownerData.ownerships[0].id, owner.ownerLookUpId)) {
                dispatch(push(`../../../ownerId/${owner.ownerLookUpId}/leases/${appContext.leaseId}`));
                setIsProvisional(true);
                setIsRealOwnerAttach(true);
            } else {
                return window.alert('Failed to attach owner.');
            }
        }
    };

    const onOwnerSelected = (lessee: IOwner) => {
        let newOwner = OwnerUtil.MapOwner(lessee);

        setValue('lesseeName', newOwner.ownerName());
        setValue('lesseeAddressLine1', newOwner.address?.addressLine1);
        setValue('lesseeAddressLine2', newOwner.address?.addressLine2);
        setValue('lesseeCity', newOwner.address?.city);
        setValue('lesseeState', newOwner.address?.state?.name);
        setValue('lesseeZipCode', newOwner.address?.zipCode);
        setValue('lesseeOwnerLookupId', newOwner.ownerLookUpId);
        if (!!newOwner.phoneNumberChanges?.phoneNumbers?.find(pn => pn.isPrimary === true)) {
            setValue('lesseePhoneNumber', newOwner.phoneNumberChanges?.phoneNumbers?.find(pn => pn.isPrimary === true).number);
        } else if (newOwner.phoneNumberChanges?.phoneNumbers?.length > 0) {
            setValue('lesseePhoneNumber', newOwner.phoneNumberChanges?.phoneNumbers[0].number);
        } else {
            setValue('lesseePhoneNumber', '');
        }
    };

    const openOwnerDialog = () => {
        if (isProvisional) {
            dialogContext.owners.manageOwner(true, onRealOwnerSelected);
        } else {
            dialogContext.owners.manageOwner(false, onOwnerSelected);
        }
    };

    // const statusBadge = (status: string) => {
    //     if (status === 'true') {
    //         return <span style={{ color: 'green' }}>✔</span>;
    //     } else {
    //         return <span>❌</span>;
    //     }
    // };

    const exerciseOption = () => {
        setValue('leasehold.optionExercised', true, { shouldDirty: true });
        dispatch(actions.layout.showDialog(DialogList.EXTEND_LEASEHOLDS));
    };

    const addAmendment = () => {
        setAmendments(
            amendments.concat([
                {
                    id: 0,
                    leaseId: appContext.leaseId,
                    createdDate: null,
                    createdByUserId: 0,
                    amendmentType: '',
                    amendedField: '',
                    oldValue: '',
                    newValue: '',
                    isRecorded: false,
                    recordedDate: new Date(),
                    book: '',
                    page: '',
                    instrumentNumber: '',
                    note: '',
                },
            ])
        );
    };

    const initializeAmendmentValues = () => {
        amendments.forEach((am, index) => {
            setValue(`leaseAmendments[${index}].id`, am.id);
            setValue(`leaseAmendments[${index}].leaseId`, am.leaseId);
            setValue(`leaseAmendments[${index}].createdDate`, am.createdDate);
            setValue(`leaseAmendments[${index}].createdByUserId`, am.createdByUserId);
            setValue(`leaseAmendments[${index}].amendmentType`, am.amendmentType);
            setValue(`leaseAmendments[${index}].amendedField`, am.amendedField);
            setValue(`leaseAmendments[${index}].oldValue`, am.oldValue);
            setValue(`leaseAmendments[${index}].newValue`, am.newValue);
            setValue(`leaseAmendments[${index}].isRecorded`, am.isRecorded);
            setValue(`leaseAmendments[${index}].recordedDate`, am.recordedDate);
            setValue(`leaseAmendments[${index}].book`, am.book);
            setValue(`leaseAmendments[${index}].page`, am.page);
            setValue(`leaseAmendments[${index}].instrumentNumber`, am.instrumentNumber);
            setValue(`leaseAmendments[${index}].note`, am.note);
        });
    };

    const displayAmendments = () => {
        if (amendments?.length > 0 && !!leaseData) {
            return amendments.map((amendment: LeaseAmendment, index: number) => {
                return (
                    <div
                        key={amendment.id}
                        style={{
                            display: 'flex',
                            border: '2px solid #ccc',
                            borderRadius: '5px',
                            flexWrap: 'wrap',
                            rowGap: '1rem',
                            alignItems: 'center',
                            justifyContent: 'space-around',
                            padding: '1rem 1rem',
                            margin: '1rem',
                        }}
                    >
                        <div className="mr-1" hidden={true}>
                            <RHFInputBox
                                label=""
                                name={`leaseAmendments[${index}].id`}
                                register={register}
                                errors={errors}
                                disabled={true}
                            />
                        </div>
                        <RHFSelect
                            name={`leaseAmendments[${index}].amendmentType`}
                            label="Amendment Type"
                            register={register}
                            options={[
                                { value: 'Terms', label: 'Terms' },
                                { value: 'Ratification', label: 'Ratification' },
                                { value: 'Misc', label: 'Misc' },
                            ]}
                            disabled={checkDisabled(index)}
                            bodyStyle={{ width: '23%', marginLeft: '1rem' }}
                            style={{ width: '100%' }}
                        />
                        <RHFSelect
                            name={`leaseAmendments[${index}].amendedField`}
                            label="Amendment Field"
                            register={register}
                            options={amendmentFields()}
                            onChange={() => updateOldValue(index)}
                            disabled={checkDisabled(index)}
                            bodyStyle={{ width: '23%' }}
                            style={{ width: '100%' }}
                        />
                        <RHFInputBox
                            name={`leaseAmendments[${index}].oldValue`}
                            label="Old Value"
                            register={register}
                            errors={errors}
                            disabled={true}
                            bodyStyle={{ width: '23%' }}
                            style={{ width: '100%' }}
                        />
                        <RHFInputBox
                            name={`leaseAmendments[${index}].newValue`}
                            label="New Value"
                            register={register}
                            errors={errors}
                            disabled={checkDisabled(index)}
                            bodyStyle={{ width: '23%', marginRight: '1.2rem' }}
                            style={{ width: '100%' }}
                        />
                        <RHFInputBox
                            name={`leaseAmendments[${index}].recordedDate`}
                            label="Recorded Date"
                            type="date"
                            register={register}
                            errors={errors}
                            disabled={checkDisabled(index)}
                            bodyStyle={{ width: '31%', marginLeft: '1rem' }}
                            style={{ width: '100%' }}
                        />
                        <RHFInputBox
                            name={`leaseAmendments[${index}].book`}
                            label="Book"
                            register={register}
                            errors={errors}
                            disabled={checkDisabled(index)}
                            bodyStyle={{ width: '31%' }}
                            style={{ width: '100%' }}
                        />
                        <RHFInputBox
                            name={`leaseAmendments[${index}].page`}
                            label="Page"
                            register={register}
                            errors={errors}
                            disabled={checkDisabled(index)}
                            bodyStyle={{ width: '31%', marginRight: '1rem' }}
                            style={{ width: '100%' }}
                        />
                    </div>
                );
            });
        } else {
            return <div>No Amendments</div>;
        }
    };

    const amendmentFields = () => {
        if (leaseData) {
            const fields = Object.getOwnPropertyNames(leaseData);
            let filteredFields = fields.filter((f: string) => {
                return f !== 'id' && f !== 'isGeneratedLease';
            });
            return filteredFields.map((field, index) => {
                return (
                    // <option key={index} value={field}>{field}</option>
                    { value: field, label: field }
                );
            });
        } else {
            return [{ value: 'placeholder', label: 'placeholder' }];
        }
    };

    const updateOldValue = (index: number) => {
        let rep = getValues();
        if (rep.leaseAmendments !== undefined && rep.leaseAmendments[index]?.amendedField !== undefined) {
            let leaseProp = rep.leaseAmendments[index].amendedField;
            setValue(`leaseAmendments[${index}].oldValue`, (leaseData)[leaseProp]);
        }
    };

    const checkDisabled = (index: number) => {
        let rep = getValues();
        if (rep.leaseAmendments !== undefined) {
            return parseInt(rep.leaseAmendments[index]?.id, 10) > 0;
        }
        return false;
    };

    const onLiveLease = () => {
        if (liveLeaseWindow && !liveLeaseWindow.closed) {
            liveLeaseWindow.focus();
            return;
        }

        const win = openLiveLeaseWindow();
        if (!win) {
            window.alert('Your browser blocked the Live Lease window. Allow pop-ups for LandHawk and try again.');
            return;
        }
        setLiveLeaseWindow(win);
    };

    /** The lease as Save would send it, for the Live Lease preview. Nothing is saved. */
    const buildLiveLeasePayload = (): Lease => {
        const data = finalizeData(_.cloneDeep(getValues()) as Lease);
        // Acknowledgments are saved from their own dialogs, so the form doesn't carry them.
        data.acknowledgements = leaseData?.acknowledgements ?? [];
        return data;
    };

    const liveLeaseSections: { [section in LeaseFormSection]: React.MutableRefObject<HTMLDivElement> } = {
        general: generInfoSection,
        lessee: lesseeInfoSection,
        owner: ownerInfoSection,
        tracts: tractListSection,
        terms: agreementTermSection,
        addendum: addendumSection,
        acknowledgment: acknowledgementSec,
    };

    /** A value was clicked in the Live Lease window: bring its field (or section) into view and focus it. */
    const goToLiveLeaseToken = (token: string) => {
        const target = leasePreviewTarget(token);
        if (!target) {
            return;
        }

        const form = document.getElementById('formContent');
        const field = target.field
            ? ((form.querySelector(`[name="${target.field}"]`) || form.querySelector(`[data-preview-field="${target.field}"]`)) as HTMLElement)
            : null;
        const landing = field || liveLeaseSections[target.section].current;
        if (!landing) {
            return;
        }

        ensureStyles(document, 'lh-jump-target-styles', JUMP_TARGET_CSS);
        window.focus();
        landing.scrollIntoView({ block: field ? 'center' : 'start', behavior: 'smooth' });

        const editable = (field && (field.matches('input, select, textarea') ? field : field.querySelector('.ql-editor'))) as HTMLInputElement;
        if (editable && !editable.disabled) {
            editable.focus({ preventScroll: true });
        }

        landing.classList.remove('lh-jump-target');
        landing.getBoundingClientRect();
        landing.classList.add('lh-jump-target');
    };

    const onFormInput = () => {
        liveLeasePreview.current?.notifyChange();
    };

    const updateTotalBonus = () => {
        let ref = getValues();
        if (ref.bonusAmount && ref.bonusUnits === 'flatFee') {
            setValue('totalBonus', ref.bonusAmount);
        } else if (ref.bonusAmount && ref.bonusUnits === 'perAcre') {
            setValue('totalBonus', MathUtil.cleanDollarAmount(parseFloat(ref.bonusAmount + '') * totalNet));
        }
    };

    const updateOptionTotalBonus = () => {
        let ref = getValues();
        if (ref.leasehold?.optionBonusAmount && ref.leasehold.optionBonusAmountUnits === 'flatFee') {
            setValue('leasehold.optionTotalBonus', ref.leasehold.optionBonusAmount);
        } else if (ref.leasehold?.optionBonusAmount && ref.leasehold.optionBonusAmountUnits === 'perAcre') {
            setValue('leasehold.optionTotalBonus', MathUtil.cleanDollarAmount(parseFloat(ref.leasehold.optionBonusAmount + '') * totalNet));
        }
    };

    const onChangeProvisionalNetAcres = (value: number) => {
        setTotalNet(value);
    };

    const updateTotalRent = () => {
        let ref = getValues();

        if (ref.rentalAmount && ref.rentalPaymentUnit === 'flatFee') {
            setValue('rentalTotalRent', parseFloat(ref?.rentalAmount + ''));
        } else if (ref.rentalAmount && ref.rentalPaymentUnit === 'perAcre') {
            setValue('rentalTotalRent', MathUtil.cleanDollarAmount(parseFloat(ref.rentalAmount + '') * totalNet));
        }

        updateTotalConsideration();
    };

    const updateTotalConsideration = () => {
        let ref = getValues();
        let considerationAmount: number = parseFloat(watchConsiderationAmount + '');

        if (isNaN(considerationAmount) && (!ref.prepaidRental)) {
            setValue('totalConsideration', '');
        } else {
            let totalConsideration = !isNaN(considerationAmount) ? considerationAmount : 0;
            let totalBonus: number = ref?.totalBonus ? parseFloat(ref?.totalBonus + '') : 0;
            let totalRental: number = 0;
            if (ref?.prepaidRental === true) {
                totalRental = ref?.rentalTotalRent ? parseFloat(ref?.rentalTotalRent + '') : 0;
            }

            totalConsideration += totalBonus + totalRental;

            setValue('totalConsideration', MathUtil.cleanDollarAmount(parseFloat(totalConsideration + '')));
        }
    };

    const resetLeaseholdsExtension = () => {
        dispatch(actions.layout.hideDialog());
        getLeaseData();
    };

    const scrollToSection = (ref: AnyObject) => {
        const formElem = document.getElementById('formContent');

        formElem.scrollTo({
            top: ref.current.offsetTop - 336,
            behavior: 'smooth',
        });
    };

    const correctOwnerName = () => {
        if (!!ownerData?.ownerDetails) {
            const ownerInfo = OwnerUtil.MapOwner(ownerData?.ownerDetails);

            if (ownerInfo instanceof OwnerIndividual) {
                return `${ownerInfo?.firstName}${ownerInfo?.middleName ? ` ${ownerInfo?.middleName} ` : ' '}${ownerInfo?.lastName}`;
            } else {
                return ownerInfo.ownerName();
            }
        }
        return 'N/A';
    };
    const refreshLease = (listener: boolean) => {
        if (listener === true) {
            getLeaseData();
        }
    };

    // Function to get the correct counties of the tracts wihout duplicates
    const addressRendering = (t: Array<ContractGenerationTractDetail>) => {
        let tracts: ContractGenerationTractDetail[] = t;
        let tractCounties: string[] = [];

        for (let i = 0; i < tracts?.length; ++i) {
            let countyExist: string = tractCounties?.find((c) => c === tracts[i]?.county?.name);

            if (tractCounties.length === 0 && !countyExist) {
                tractCounties.push(tracts[i]?.county?.name);
                setTractState(tracts[i]?.county?.stateId);
                continue;
            }

            if (!!countyExist && !!countyExist.includes(tracts[i]?.county?.name)) {
                continue;
            } else {
                tractCounties.push(tracts[i]?.county?.name);
            }
        }

        setCounties(tractCounties);
    };

    const tractLocationInfo = () => {
        let stateName: State = !!states ? states?.items?.find((s) => s.id === tractState) : undefined;

        if (!!counties && !!stateName) {
            let tractLocation: LocationModel = {
                counties: counties,
                state: stateName?.name,
            };

            setLocation(tractLocation);
        }
    };

    return (
        <div>
            <div style={{ height: '74.2vh', overflow: 'hidden' }}>
                {(appContext?.leaseId === 0 || !appContext?.leaseId) && (
                    <>
                        <div
                            id="dirtyFlag"
                            style={{
                                position: 'fixed',
                                top: '4.7rem',
                                left: '0',
                                width: '100%',
                                height: '3rem',
                                color: 'white',
                                backgroundColor: 'rgba(255,0,0,.5)',
                                zIndex: 9000,
                                padding: '1rem 0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            New Lease
                        </div>
                    </>
                )}

                <div>
                    <div style={{ textAlign: 'center' }}>
                        {/* <span style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>Lease Generation</span> */}
                        <h1 style={{ marginTop: '0', marginBottom: '1rem' }}>Lease Generation</h1>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '3rem', margin: 'auto 5rem' }}>
                        <div style={{ display: 'flex', marginBottom: '1rem', gap: '1rem', flexDirection: 'column' }}>
                            {/* add header with owner info */}
                            <div style={{ marginRight: '1rem' }}>
                                <span style={{ marginRight: '0.5rem', fontWeight: 'bold' }} className="header-info">
                                    Agreement Type:
                                </span>
                                {(!leaseData || leaseData?.id === 0) &&
                                    <span className="header-info" style={{ fontWeight: 'bold', color: '#6393c1' }}>
                                        {newLeaseType === '1' ? 'Paid Up' : (newLeaseType === '2' ? 'Top Lease' : (newLeaseType === '3' ? 'Rental Lease' : 'Unknown'))}
                                    </span>
                                }
                                {leaseData?.id > 0 &&
                                    <span className="header-info" style={{ fontWeight: 'bold', color: '#6393c1' }}>
                                        {leaseData?.isTopLease ? 'Top Lease' : (leaseData?.isRentalLease ? 'Rental Lease' : ((!leaseData?.isTopLease && !leaseData?.isRentalLease) ? 'Paid Up Lease' : 'Unknown'))}
                                    </span>
                                }
                            </div>
                            <div style={{ marginRight: '1rem' }}>
                                <span style={{ marginRight: '0.5rem', fontWeight: 'bold' }} className="header-info">
                                    Owner:
                                </span>
                                <span className="header-info" style={{ fontWeight: 'bold', color: '#6393c1' }}>
                                    {correctOwnerName()}
                                </span>
                            </div>
                            <div style={{ marginRight: '1rem' }}>
                                <span style={{ marginRight: '0.5rem', fontWeight: 'bold' }} className="header-info">
                                    Doc Number:
                                </span>
                                <span className="header-info" style={{ fontWeight: 'bold', color: '#6393c1' }}>
                                    {(leaseData?.leaseNumber + (isProvisional === true ? '- P' : '')) || 'N/A'}
                                </span>
                            </div>
                            <div style={{ marginRight: '1rem' }}>
                                <span style={{ marginRight: '0.5rem', fontWeight: 'bold' }} className="header-info">
                                    Invoice Status:
                                </span>
                                <span className="header-info" style={{ fontWeight: 'bold', color: '#6393c1' }}>
                                    {invoiceData?.length > 0 ? invoiceData.map((it, index) => {
                                        let status = 'Pending';
                                        if (!!it.voidDate) {
                                            status = 'VOID';
                                        } else if (!!it.checkDate) {
                                            status = 'PAID';
                                            status += !!it.paidDate ? '' : ', NOT FUNDED';
                                        } else if (!!it.paidDate) {
                                            status = 'FUNDED';
                                        } else if (!!it.arDate) {
                                            status = 'POSTED';
                                            console.log('just to updates');
                                        }
                                        let numFull = it.fullInvoiceNumber;
                                        return <span key={index}> {numFull}: {status} </span>;
                                    }) : 'N/A'}
                                </span>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '2rem', alignItems: 'center', bottom: '1rem' }}>
                            <div style={{ marginRight: '1rem' }}>
                                <span style={{ marginRight: '0.5rem', fontWeight: 'bold' }} className="header-info">
                                    Agreement Status:
                                </span>
                                <span className="header-info" style={{ fontWeight: 'bold', color: 'rgba(255,0,0,.5)' }}>
                                    {!!leaseData?.isCommitted && !!leaseData?.isInHand && 'Committed & In-Handed'}
                                    {!!leaseData?.isCommitted && !leaseData?.isInHand && 'Committed'}
                                    {!leaseData?.isCommitted && !!leaseData?.isInHand && 'In-Handed'}
                                    {!leaseData?.isCommitted && !leaseData?.isInHand && !leaseData?.isVoid && 'Rough-Draft'}
                                    {!!leaseData?.isVoid && !leaseData?.isInHand && !leaseData?.isCommitted && 'Void'}
                                </span>
                            </div>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                {(leaseData?.isCommitted === false || leaseData?.isCommitted === null || leaseData?.isCommitted === undefined) &&
                                    <Button className="blue-hover-button" text="Commit Agreement" onClick={showStatusDialog} disabled={isNewLease || formLoading} />}
                                {leaseData?.isCommitted === true &&
                                    <Button className="blue-hover-button" text="Uncommit Agreement" onClick={showUncommitConfirmationDialog} disabled={isNewLease || formLoading} />}
                                {!leaseData?.isInHand && <Button className="blue-hover-button" text="In-Hand Agreement" onClick={onInHand} disabled={isNewLease || formLoading || calmsSubmitting} />}
                                {/* tslint:disable-next-line: max-line-length */}
                                {leaseData?.isInHand && appContext.currentUser.isAdmin && <Button className="blue-hover-button" text="Revoke In-Hand" onClick={showConfirmRevokeInhandDialog} disabled={isNewLease || formLoading || calmsSubmitting} />}
                                <Button className="blue-hover-button" text="Live Lease" onClick={onLiveLease} disabled={formLoading} />
                                {liveLeaseWindow && (
                                    <LiveLeaseWindow
                                        ref={liveLeasePreview}
                                        win={liveLeaseWindow}
                                        clientNumber={appContext.clientNumber}
                                        projectNumber={appContext.projectNumber}
                                        title={`Live Lease - ${leaseData?.leaseNumber || 'new lease'} - ${correctOwnerName()}`}
                                        buildPayload={buildLiveLeasePayload}
                                        onTokenClick={goToLiveLeaseToken}
                                        onClose={() => setLiveLeaseWindow(null)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* <dialog></dialog> */}

                <div style={{ display: 'flex', height: '57vh', gap: '1rem' }}>
                    <div
                        style={{
                            backgroundColor: '#6393c1',
                            width: '20rem',
                            color: 'white',
                            overflowY: 'scroll',
                            scrollbarWidth: 'none',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-evenly'
                        }}
                    >
                        <section style={{ textAlign: 'center' }}>
                            <h3 style={{ fontSize: '1.75rem', margin: '.3rem 0' }}>Agreement Sections</h3>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(generInfoSection)}
                        >
                            <span>General Information</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(lesseeInfoSection)}
                        >
                            <span>Lessee Information</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(ownerInfoSection)}
                        >
                            <span>Owner Information</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(tractListSection)}
                        >
                            <span>Tract List Section</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(agreementTermSection)}
                        >
                            <span>Agreement Terms</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(addendumSection)}
                        >
                            <span>Addendum Section</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(adHocSection)}
                        >
                            <span>Ad Hoc Section</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(acknowledgementSec)}
                        >
                            <span>Acknowledgement Section</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(docManagSection)}
                        >
                            <span>Doc & Manag Section</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(pmSection)}
                        >
                            <span>Maintenance Section</span>
                        </section>
                        <section
                            className="border-hover-effect"
                            onClick={() => scrollToSection(lrSection)}
                        >
                            <span>Lease Recording Section</span>
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section style={{ textAlign: 'center', marginTop: '1rem', marginBottom: '2rem' }}>
                            <button style={{ padding: '1rem' }} form="contractForm" disabled={(!tractsSelected || formLoading) && ownerData?.tracts?.length !== 0}>
                                Save & Submit
                            </button>
                            {/* <Button text="Save & Submit" intent="primary" formId="contractForm" /> */}
                        </section>
                        <hr style={{ margin: '0', color: '#ccc' }} />
                        <section style={{ background: 'black' }} />
                    </div>
                    <div id="formContent" style={{ maxHeight: '70vh', overflowY: 'scroll', width: '85%' }}>
                        <form id="contractForm" onSubmit={handleSubmit(onSubmit)} onInput={onFormInput}>
                            {/* <div>
                            <Button text="Save" type="submit" intent="primary" />
                        </div> */}

                            <div>
                                {/* <RHFLegend title="Agreement Status" />
                            <div style={{ display: 'flex', fontSize: '1.5rem', marginBottom: '1rem' }}>
                                <div style={{ marginRight: '1rem' }}>
                                    {statusBadge(watchStatusFields.isCommitted ? watchStatusFields.isCommitted.toString() : undefined)}
                                    <span style={{ marginLeft: '0.5rem' }}>Committed</span>
                                </div>

                                <div style={{ marginRight: '1rem' }}>
                                    {statusBadge(watchStatusFields.isInHand ? watchStatusFields.isInHand.toString() : undefined)}
                                    <span style={{ marginLeft: '0.5rem' }}>In-Hand</span>
                                </div>

                                <div>
                                    {statusBadge(watchStatusFields.isTransferred ? watchStatusFields.isTransferred.toString() : undefined)}
                                    <span style={{ marginLeft: '0.5rem' }}>Transferred</span>
                                </div>
                            </div> */}

                                {/* <div>
                                <div>
                                    <div className="form-row" style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Button text="Commit Agreement" style={{ marginBottom: '7px', height: '3rem' }} onClick={onCommit} />
                                        <input type="hidden" name="isCommitted" ref={register()} />
                                        <RHFInputBox
                                            style={{ marginRight: '1rem' }}
                                            type="date"
                                            name="committedDate"
                                            label="Committed Date"
                                            register={register}
                                            errors={errors}
                                        />

                                        <Button text="In-Hand Agreement" style={{ marginBottom: '7px', height: '3rem' }} onClick={onInHand} />
                                        <input type="hidden" name="isInHand" ref={register()} />
                                        <RHFInputBox
                                            style={{ marginRight: '1rem' }}
                                            type="date"
                                            name="inHandDate"
                                            label="In-Hand Date"
                                            register={register}
                                            errors={errors}
                                        />

                                        <Button text="Transfer Agreement" style={{ marginBottom: '7px', height: '3rem' }} onClick={onTransfer} />
                                <input type="hidden" name="isTransfer" ref={register()} />
                                <RHFInputBox type="date" name="transferDate" label="Transfer Date" register={register} errors={errors} />
                                    </div>
                                </div>
                            </div> */}

                                {(isDirty || deltasAdded) && !isNewLease && !formLoading && (
                                    <>
                                        <div
                                            id="dirtyFlag"
                                            style={{
                                                position: 'fixed',
                                                top: '4.7rem',
                                                left: '0',
                                                width: '100%',
                                                height: '3rem',
                                                color: 'white',
                                                backgroundColor: 'rgba(255,0,0,.5)',
                                                padding: '1rem 0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <div>Unsaved Changes - Please Save Before Leaving Form</div>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    right: '.5rem',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    display: 'flex',
                                                }}
                                            >
                                                <div>
                                                    <Button
                                                        text="Save"
                                                        type="submit"
                                                        size="small"
                                                        intent="primary"
                                                        disabled={!tractsSelected || formLoading}
                                                        style={{ height: '2.5rem' }}
                                                    />
                                                </div>
                                                <div style={{ margin: '0 1rem', borderRight: '1px solid white', width: '1px' }} />
                                                <Button
                                                    className="blue-hover-button"
                                                    text="Cancel Changes"
                                                    size="small"
                                                    onClick={() => reset(initialValues())}
                                                    style={{ height: '2.5rem' }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                                {formLoading && !(appContext.ownerId === 0) && (
                                    <div
                                        id="dirtyFlag"
                                        style={{
                                            position: 'fixed',
                                            top: '4.7rem',
                                            left: '0',
                                            width: '100%',
                                            height: '3rem',
                                            color: 'white',
                                            backgroundColor: 'rgba(255,0,0,.5)',
                                            zIndex: 9000,
                                            padding: '1rem 0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <div>Loading Data...</div>
                                    </div>
                                )}
                                {calmsSubmitting && (
                                    <div
                                        style={{
                                            position: 'fixed',
                                            top: '4.7rem',
                                            left: '0',
                                            width: '100%',
                                            height: '3rem',
                                            color: 'white',
                                            backgroundColor: 'rgba(0,100,200,.7)',
                                            zIndex: 9000,
                                            padding: '1rem 0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <div>Submitting to Oracle... Please wait.</div>
                                    </div>
                                )}

                                <div ref={generInfoSection} style={{ marginBottom: '3rem' }}>
                                    <RHFLegend title="General Information" />
                                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                                        <RHFInputBox
                                            type="text"
                                            name="clientDocNumber"
                                            label="Client Doc Number"
                                            register={register}
                                            errors={errors}
                                            disabled={isInHanded}
                                            bodyStyle={{ width: '31%', marginLeft: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            type="text"
                                            name="leasedBy"
                                            label="Leased By"
                                            register={register}
                                            errors={errors}
                                            disabled={isInHanded}
                                            bodyStyle={{ width: '31%' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            type="text"
                                            name="reminderNote"
                                            label="Reminder Note"
                                            register={register}
                                            errors={errors}
                                            disabled={isInHanded}
                                            bodyStyle={{ width: '31%', marginRight: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', marginTop: '1rem' }}>
                                        <RHFInputBox
                                            type="date"
                                            name="reminderDate"
                                            label="Reminder Date"
                                            register={register}
                                            errors={errors}
                                            disabled={isInHanded}
                                            bodyStyle={{ width: '31%', marginLeft: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        {/* <RHFInputBox type="hidden" name="leaseNumber" label="" register={register} errors={errors} /> */}
                                        <input type="hidden" name="leaseNumber" ref={register()} />
                                        <input type="hidden" name="lesseeOwnerLookupId" ref={register()} />
                                        <input type="hidden" name="originalInHandDate" ref={register()} />
                                        <RHFInputBox
                                            type="date"
                                            name="committedDate"
                                            label="Committed Date"
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                            bodyStyle={{ width: '31%' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            type="date"
                                            name="inHandDate"
                                            label="In-Hand Date"
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                            bodyStyle={{ width: '31%', marginRight: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </div>

                                <div ref={lesseeInfoSection} style={{ marginBottom: '3rem' }}>
                                    <RHFLegend title="Lessee Information" />

                                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', rowGap: '1rem' }}>
                                        <RHFInputBox
                                            rules={{ required: 'field required' }}
                                            name="lesseeName"
                                            label="Lessee"
                                            register={register}
                                            errors={errors}
                                            isRequired={true}
                                            disabled={true}
                                            bodyStyle={{ width: '31%', marginLeft: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name="originalLessee"
                                            label="Original Lessee"
                                            register={register}
                                            errors={errors}
                                            disabled={isInHanded}
                                            bodyStyle={{ width: '31%' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFCheckbox
                                            name="isNotOriginalLessee"
                                            label="Not Original Lessee"
                                            register={register}
                                            errors={errors}
                                            disabled={isInHanded}
                                            bodyStyle={{ width: '31%', marginTop: '1.5rem', marginRight: '1rem' }}
                                        />
                                        <RHFInputBox
                                            rules={{ required: 'field required' }}
                                            name="lesseeAddressLine1"
                                            label="Address Line 1"
                                            register={register}
                                            errors={errors}
                                            isRequired={true}
                                            disabled={true}
                                            bodyStyle={{ width: '47%', marginLeft: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name="lesseeAddressLine2"
                                            label="Address Line 2"
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                            bodyStyle={{ width: '47%', marginRight: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name="lesseeCity"
                                            label="City"
                                            register={register}
                                            errors={errors}
                                            rules={{ required: 'field required' }}
                                            isRequired={true}
                                            disabled={true}
                                            bodyStyle={{ width: '31%', marginLeft: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFSelect
                                            label="State"
                                            name="lesseeState"
                                            options={
                                                !!states
                                                    ? states?.items?.map((s) => {
                                                        return { value: s.name, label: `${s.name}` };
                                                    })
                                                    : []
                                            }
                                            register={register}
                                            errors={errors}
                                            rules={{ required: 'field required' }}
                                            defaultVal={!!leaseData ? `${leaseData.lesseeState}` : ''}
                                            isRequired={true}
                                            disabled={true}
                                            bodyStyle={{ width: '31%' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name="lesseeZipCode"
                                            label="Zip Code"
                                            register={register}
                                            errors={errors}
                                            isRequired={true}
                                            disabled={true}
                                            bodyStyle={{ width: '31%', marginRight: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name="lesseePhoneNumber"
                                            label="Phone Number"
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                            bodyStyle={{ width: '31%', marginLeft: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name="lesseeSignatureType"
                                            label="Signature Type"
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                            bodyStyle={{ width: '31%' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name="lesseeSignature"
                                            label="Signature"
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                            bodyStyle={{ width: '31%', marginRight: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name="lesseeAcknowledgement"
                                            label="Acknowledgement"
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                            bodyStyle={{ width: '97%', marginLeft: '1rem', marginRight: '1rem' }}
                                            style={{ width: '100%' }}
                                        />
                                        {/* conditional render based on not original lessee checkbox */}
                                    </div>

                                    {/* <div>
                                <RHFCheckbox
                                    name="isNotOriginalLessee"
                                    label="Not Original Lessee"
                                    register={register}
                                    errors={errors}
                                    bodyStyle={{ width: '150px' }}
                                />
                            </div> */}

                                    {/* <div>
                                <RHFInputBox
                                    name="lesseeCity"
                                    label="City"
                                    register={register}
                                    errors={errors}
                                    rules={{ required: 'field required' }}
                                />
                                <RHFInputBox
                                    name="lesseeState"
                                    label="State"
                                    register={register}
                                    errors={errors}
                                    rules={{ required: 'field required' }}
                                />
                                <RHFInputBox name="lesseeZipCode" label="Zip Code" register={register} errors={errors} />
                                <RHFInputBox name="lesseePhoneNumber" label="Phone Number" register={register} errors={errors} />
                                <RHFInputBox name="lesseeSignature" label="Signature" register={register} errors={errors} />
                                <RHFInputBox name="lesseeAcknowledgement" label="Acknowledgement" register={register} errors={errors} />
                                <RHFInputBox name="lesseeSignatureType" label="Signature Type" register={register} errors={errors} />
                            </div> */}

                                    {/* <div className="form-row"> */}
                                    {/* <RHFCheckbox name="isNotOriginalLessee" label="Not Original Lessee" register={register} errors={errors} /> */}
                                    {/* conditional render based on not original lessee checkbox */}
                                    {/* <RHFInputBox name="originalLessee" label="Original Lessee" register={register} errors={errors} /> */}
                                    {/* </div> */}

                                    <div className="mt-3 ml-2">
                                        <Button
                                            className="blue-hover-button"
                                            text="USE DEFAULT LESSEE"
                                            onClick={useDefaultLessee}
                                            disabled={isInHanded}
                                            style={{ marginLeft: '.5rem', marginRight: '.5rem' }}
                                        />
                                        <Button
                                            className="blue-hover-button"
                                            text="USE DIFFERENT LESSEE"
                                            onClick={openOwnerDialog}
                                            disabled={isInHanded}
                                            style={{ marginLeft: '.5rem' }}
                                        />
                                        {/* <Button text="CREATE LESSEE" /> */}
                                    </div>
                                </div>

                                {/* conditional render based on lease type */}
                                {(newLeaseType === '3' || leaseData?.isRentalLease) && (
                                    <div style={{ marginBottom: '2rem' }}>
                                        <RHFLegend title="Rental Lease Information" />
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                justifyContent: 'space-between',
                                                rowGap: '1rem',
                                                padding: '0 1rem',
                                            }}
                                        >
                                            <RHFInputBox
                                                type="text"
                                                name="rentalBankName"
                                                label="Bank Name"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                isRequired={true}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                type="text"
                                                name="rentalAddress"
                                                label="Address"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                isRequired={true}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                type="text"
                                                name="rentalCity"
                                                label="City"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                isRequired={true}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                type="text"
                                                name="rentalState"
                                                label="State"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                isRequired={true}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                type="text"
                                                name="rentalZipCode"
                                                label="Zip Code"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                isRequired={true}
                                                disabled={isInHanded}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* conditional render based on lease type */}
                                {(newLeaseType === '2' || leaseData?.isTopLease) && (
                                    <div style={{ marginBottom: '2rem' }}>
                                        <RHFLegend title="Top Lease Information" />
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', rowGap: '1rem' }}>
                                            <RHFInputBox
                                                name="topLeasePercentDown"
                                                label="Percent Down"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                name="topLeaseAmount"
                                                label="Amount"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                name="topLeaseRemainingBalance"
                                                label="Remaining Balance"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                name="topLeaseDraftType"
                                                label="Draft Type"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                name="topLeaseDraftDays"
                                                label="Draft Days"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                name="topLeaseBalanceReminder"
                                                label="Balance Reminder"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />

                                            <RHFInputBox
                                                name="topLeaseNote"
                                                label="Top Lease Note"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />

                                            <RHFInputBox
                                                name="topLeaseRecordedType"
                                                label="Recorded Type"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                name="topLeaseBook"
                                                label="Book"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                name="topLeasePage"
                                                label="Page"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                type="date"
                                                name="topLeaseActiveDate"
                                                label="Active Date"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                type="date"
                                                name="topLeaseExpirationDate"
                                                label="Expiration Date"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />

                                            <RHFInputBox
                                                name="topLeaseOriginalLessor"
                                                label="Original Lessor"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                            <RHFInputBox
                                                name="topLeaseOriginalLessee"
                                                label="Original Lessee"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={isInHanded}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* make multi owner */}
                                <div ref={ownerInfoSection} style={{ marginBottom: '2rem' }}>
                                    <RHFLegend title="Owner Information" />

                                    <div style={{ marginBottom: '1rem' }}>
                                        {/* owner info label here */}
                                        {displayOwnerDetails()}
                                    </div>

                                    <div style={{ marginBottom: '1rem' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 2rem 1rem 2rem' }}>
                                            <RHFInputBox
                                                name="ownersOnDocument"
                                                label="Owners on Document"
                                                register={register}
                                                errors={errors}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '50%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                name="ownersSSNTaxIdOnDocument"
                                                label="Owner SSN/Tax Id on Document"
                                                register={register}
                                                errors={errors}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '50%' }}
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 2rem 1rem 2rem' }}>
                                            <RHFInputBox
                                                name="ownersAddressOnDocument"
                                                label="Owner Address on Document"
                                                register={register}
                                                errors={errors}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '100%' }}
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <div style={{ margin: '0 2rem 1rem 2rem' }}>
                                            {/* <RHFInputBox name="clientFacingNotes" label="Buyer Lease Notes" register={register} errors={errors} /> */}
                                            <label>Buyer Lease Notes</label>
                                            <textarea
                                                name="clientFacingNotes"
                                                ref={register()}
                                                style={{ width: '100%', height: '10rem' }}
                                                disabled={isInHanded}
                                            />
                                        </div>
                                        <div style={{ margin: 'auto 2rem' }}>
                                            <Button className="blue-hover-button" text="Use Owner Info" onClick={updateOwnerData} disabled={isInHanded} />
                                            {isProvisional === true && <Button
                                                className="blue-hover-button"
                                                text="ATTACH REAL OWNER"
                                                onClick={showAttachOwnerDialog}
                                                disabled={isInHanded}
                                                style={{ marginLeft: '.5rem' }}
                                            />}
                                        </div>
                                    </div>
                                </div>

                                <div ref={tractListSection} style={{ marginBottom: '2rem' }}>
                                    <div style={{ margin: 'auto 2rem' }}>
                                        <RHFLegend title="Tract List" />
                                        {/* add Tract List here */}
                                        {ownerData?.tracts?.length > 0 ? (
                                            <LeasingTractList
                                                totalGross={totalGross}
                                                totalNet={totalNet}
                                                register={register}
                                                errors={errors}
                                                includeTract={updateLegalDescription}
                                                tracts={leaseTractList}
                                                originalTractList={originalTractList}
                                                inHand={isInHanded}
                                                parentTractType={project?.currentProject?.tractTypeName}
                                                landType={project?.currentProject?.landSystemId}
                                                contractType={LandContractType.OilAndGas}
                                                clientNumber={appContext.clientNumber}
                                                projectNumber={appContext.projectNumber}
                                                tractLimit={['Mineral', 'Open']}
                                                ownerData={ownerData}
                                                isTopLease={newLeaseType === '2' || leaseData?.isTopLease}
                                            />
                                        ) : (
                                            <div>No Tracts</div>
                                        )}

                                        <div>
                                            <span>
                                                Legal Description ({' '}
                                                {!moveLegalDescription ? (
                                                    '0'
                                                ) : moveLegalDescription?.length > 1000 ? (
                                                    <abbr style={{ color: 'red' }} title="Legal Description moved to Exhibit A">
                                                        {moveLegalDescription?.length}
                                                    </abbr>
                                                ) : (
                                                    moveLegalDescription?.length
                                                )}{' '}
                                                / 1000 )
                                            </span>
                                            {/* <RHFTextArea
                                                label=""
                                                name="legalDescription"
                                                register={register}
                                                style={{ width: '100%', height: '10rem' }}
                                                rules={{ required: 'field required', minLength: 1 }}
                                                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setMoveLegalDescription(e.target.value)}
                                                isRequired={true}
                                                disabled={isInHanded}
                                            /> */}
                                            <div data-preview-field="rteLegalDescription">
                                                <Controller
                                                    name="rteLegalDescription"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ onChange, onBlur, value }) => (
                                                        <ReactQuill theme="snow" value={value} onChange={onChange} onBlur={onBlur} />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ margin: 'auto 2rem' }}>
                                    <RHFTextArea
                                        name="shortLegalDescription"
                                        label="Short Legal Description"
                                        register={register}
                                        style={{ width: '100%', height: '5rem' }}
                                    />
                                </div>

                                <div ref={agreementTermSection} style={{ marginBottom: '2rem' }}>
                                    <RHFLegend title="Agreement Terms" />

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                            <RHFInputBox
                                                name="leasehold.royalty"
                                                label="Royalty"
                                                register={register}
                                                errors={errors}
                                                type="number"
                                                rules={{ required: 'field required', min: { value: 0.1, message: 'must be a positive value' } }}
                                                step={0.00001}
                                                isRequired={true}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '23%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                rules={{ required: 'field required' }}
                                                type="date"
                                                name="leaseDate"
                                                label="Lease Date"
                                                register={register}
                                                errors={errors}
                                                isRequired={true}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '23%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                rules={{ required: 'field required' }}
                                                type="date"
                                                name="effectiveDate"
                                                label="Effective Date"
                                                register={register}
                                                errors={errors}
                                                isRequired={true}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '23%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                type="date"
                                                name="leasehold.expirationDate"
                                                label="Expiration Date"
                                                register={register}
                                                errors={errors}
                                                disabled={true}
                                                bodyStyle={{ width: '23%', marginRight: '1rem' }}
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                            <RHFInputBox
                                                type="number"
                                                name="leasehold.primaryTerm"
                                                label="Term"
                                                register={register}
                                                errors={errors}
                                                rules={{ required: 'field required', min: { value: 0.1, message: 'must be a positive value' } }}
                                                isRequired={true}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '18%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFSelect
                                                name="leasehold.primaryTermUnits"
                                                label="Term Unit"
                                                options={[
                                                    { value: 'years', label: 'Years' },
                                                    { value: 'months', label: 'Months' },
                                                    { value: 'days', label: 'Days' },
                                                ]}
                                                register={register}
                                                errors={errors}
                                                rules={{ required: 'field required' }}
                                                isRequired={true}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '18%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                name="bonusAmount"
                                                label="Bonus Amount"
                                                register={register}
                                                errors={errors}
                                                onChange={() => updateTotalBonus()}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '18%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFSelect
                                                name="bonusUnits"
                                                label="Bonus Unit"
                                                options={[
                                                    { value: 'flatFee', label: 'Flat Fee' },
                                                    { value: 'perAcre', label: 'Per Acre' },
                                                ]}
                                                register={register}
                                                errors={errors}
                                                onChange={() => updateTotalBonus()}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '18%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                name="totalBonus"
                                                label="Total Bonus"
                                                register={register}
                                                errors={errors}
                                                disabled={true}
                                                bodyStyle={{ width: '18%', marginRight: '1rem' }}
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '1rem' }}>
                                            <RHFInputBox
                                                name="bankingDays"
                                                label="Banking Days"
                                                register={register}
                                                errors={errors}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '18%', marginRight: '1rem' }}
                                                style={{ width: '100%' }}
                                            />

                                            <RHFSelect
                                                name="bankingDaysUnit"
                                                label="Banking Days Unit"
                                                options={[
                                                    { value: 'banking', label: 'Banking' },
                                                    { value: 'business', label: 'Business' },
                                                    { value: 'calendar', label: 'Calendar' },
                                                ]}
                                                register={register}
                                                errors={errors}
                                                disabled={isInHanded}
                                                bodyStyle={{ width: '18%' }}
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        {isProvisional === true &&
                                            <div>
                                                <RHFInputBox
                                                    name="leasehold.provisionalGrossAcres"
                                                    label="Gross Acres"
                                                    register={register}
                                                    errors={errors}
                                                    bodyStyle={{ width: '150px' }}
                                                />
                                                <RHFInputBox
                                                    name="leasehold.provisionalNetAcres"
                                                    label="Net Acres"
                                                    register={register}
                                                    errors={errors}
                                                    bodyStyle={{ width: '150px' }}
                                                    onChange={(e: React.FormEvent<HTMLInputElement>) => onChangeProvisionalNetAcres(Number(e.currentTarget.value))}
                                                />
                                            </div>}
                                        {(newLeaseType === '3' || leaseData?.isRentalLease) && (
                                            <div style={{ margin: '2rem auto' }}>
                                                <RHFLegend title="Rental Agreement" />
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        justifyContent: 'space-between',
                                                        marginBottom: '1rem',
                                                        height: '50px',
                                                    }}
                                                >
                                                    <RHFInputBox
                                                        type="date"
                                                        name="rentalDueDate"
                                                        label="Due Date"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                        disabled={isInHanded}
                                                    />
                                                    <RHFInputBox
                                                        type="text"
                                                        name="rentalAmount"
                                                        label="Amount"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                        disabled={isInHanded}
                                                    />
                                                    <RHFSelect
                                                        name="rentalPaymentUnit"
                                                        label="Rental Unit"
                                                        options={[
                                                            { value: 'flatFee', label: 'Flat Fee' },
                                                            { value: 'perAcre', label: 'Per Acre' },
                                                        ]}
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                        disabled={isInHanded}
                                                    />
                                                    <RHFInputBox
                                                        type="text"
                                                        name="rentalTotalRent"
                                                        label="Total Rent"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                        disabled={true}
                                                    />
                                                    <RHFCheckbox
                                                        label="Prepaid Rental"
                                                        name="prepaidRental"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px', display: 'flex', alignItems: 'center', gap: '1rem' }}
                                                        disabled={isInHanded}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <div
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                justifyContent: 'space-between',
                                                marginBottom: '2rem',
                                                height: '50px',
                                            }}
                                        >
                                            <RHFCheckbox
                                                name="isAddConsideration"
                                                label="Additional Consideration"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '200px', display: 'flex', alignItems: 'center', gap: '1rem' }}
                                                disabled={isInHanded}
                                            />

                                            {watchOptionFields.isAddConsideration && (
                                                <>
                                                    {/* conditional render based on add consideration checkbox */}
                                                    <RHFInputBox
                                                        name="addConsiderationExplanation"
                                                        label="Add Consideration Explanation"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '400px' }}
                                                        style={{ width: '400px' }}
                                                    />
                                                    <RHFInputBox
                                                        name="addConsiderationAmount"
                                                        label="Add Consideration Amount"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '180px' }}
                                                        style={{ width: 'auto' }}
                                                    />
                                                </>
                                            )}
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', marginBottom: '2rem' }}>
                                            <RHFInputBox
                                                name="totalConsideration"
                                                label="Total Consideration"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px' }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                justifyContent: 'space-between',
                                                marginBottom: '1rem',
                                                height: '50px',
                                            }}
                                        >
                                            <RHFCheckbox
                                                name="leasehold.renewalOption"
                                                label="Option to Extend"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px', display: 'flex', alignItems: 'center', gap: '1rem' }}
                                                disabled={isInHanded}
                                            />

                                            {watchOptionFields['leasehold.renewalOption'] && (
                                                <>
                                                    {/* conditional render based on option checkbox */}
                                                    <RHFInputBox
                                                        type="number"
                                                        name="leasehold.optionBonusAmount"
                                                        label="Option Bonus Amount"
                                                        register={register}
                                                        errors={errors}
                                                        onChange={() => updateOptionTotalBonus()}
                                                        bodyStyle={{ width: '150px' }}
                                                        step={.01}
                                                    />
                                                    <RHFSelect
                                                        name="leasehold.optionBonusAmountUnits"
                                                        label="Option Bonus Unit"
                                                        options={[
                                                            { value: 'flatFee', label: 'Flat Fee' },
                                                            { value: 'perAcre', label: 'Per Acre' },
                                                        ]}
                                                        register={register}
                                                        errors={errors}
                                                        onChange={() => updateOptionTotalBonus()}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                    <RHFInputBox
                                                        type="number"
                                                        name="leasehold.optionTotalBonus"
                                                        label="Total Option Bonus"
                                                        register={register}
                                                        errors={errors}
                                                        disabled={true}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                    <RHFInputBox
                                                        name="leasehold.optionTerm"
                                                        label="Option Term"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                    <RHFSelect
                                                        name="leasehold.optionTermUnits"
                                                        label="Option Term Unit"
                                                        options={[
                                                            { value: 'years', label: 'Years' },
                                                            { value: 'months', label: 'Months' },
                                                            { value: 'days', label: 'Days' },
                                                        ]}
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                </>
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                justifyContent: 'space-between',
                                                marginBottom: '1rem',
                                                height: '50px',
                                            }}
                                        >
                                            <RHFCheckbox
                                                label="Prepaid Option"
                                                name="prepaidOption"
                                                register={register}
                                                errors={errors}
                                                bodyStyle={{ width: '150px', display: 'flex', alignItems: 'center', gap: '1rem' }}
                                                disabled={isInHanded}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                justifyContent: 'space-between',
                                                rowGap: '2rem',
                                                margin: '1rem 1rem 0 1rem',
                                            }}
                                        >
                                            {watchOptionFields.isAddOptionToExtend && (
                                                <>
                                                    {/* conditional render based on additional option checkbox */}
                                                    <RHFInputBox
                                                        name="addOptionBonusAmount"
                                                        label="Add Option Bonus Amount"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                    <RHFInputBox
                                                        name="addOptionBonusUnit"
                                                        label="Add Option Bonus Unit"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                    <RHFInputBox
                                                        name="addOptionTotalBonus"
                                                        label="Add Total Option Bonus"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                    <RHFInputBox
                                                        name="addOptionTerm"
                                                        label="Add Option Term"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                    <RHFInputBox
                                                        name="addOptionTermUnits"
                                                        label="Add Option Term Unit"
                                                        register={register}
                                                        errors={errors}
                                                        bodyStyle={{ width: '150px' }}
                                                    />
                                                </>
                                            )}
                                        </div>

                                        {/* <div className="form-row">
                        
                        </div> */}

                                        {/* <RHFCheckbox name="isAddOptionToExtend" label="Second Option to Extend" register={register} errors={errors} /> */}
                                    </div>
                                </div>

                                {isInHanded && (
                                    <div className="mb-1" style={{ margin: 'auto 2rem' }}>
                                        <RHFLegend title="Provisions" />

                                        <div style={{ margin: 'auto 2rem' }}>
                                            {attachedProvisionClauses && (
                                                <ProvisionClause
                                                    attachedProvisionClauses={attachedProvisionClauses}
                                                    options={provisionClauseTypes}
                                                    formPrefix="leasehold.provisionLeaseClauses"
                                                    register={register}
                                                    errors={errors}
                                                    getValues={getValues}
                                                    setValue={setValue}
                                                    key="provisionClause"
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}

                                {!isInHanded && (
                                    <>
                                        <div style={{ marginBottom: '2rem' }} ref={addendumSection}>
                                            <RHFLegend title="Client Approved Clauses" />
                                            {/* add Addendum Clauses here */}
                                            {!!leaseData && !!contractClauses ? (
                                                <div>
                                                    <ClientApprovedLeaseClauses
                                                        contractClauses={contractClauses}
                                                        selectedClauses={selectedClauses}
                                                        isInHanded={isInHanded}
                                                        updateProcessing={updateProcessing}
                                                        getValues={getValues}
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                            ) : (
                                                <div style={{ textAlign: 'center' }}>
                                                    <p>No Addendum Clauses!</p>
                                                </div>
                                            )}
                                        </div>

                                        {leaseClauseTypes?.length > 0 && (
                                            <div ref={adHocSection} style={{ marginBottom: '4rem' }}>
                                                <RHFLegend title="Ad Hoc Clauses" />
                                                {/* add Ad Hoc Clauses here */}
                                                <AdHocClauses
                                                    register={register}
                                                    errors={errors}
                                                    getValues={getValues}
                                                    setValue={setValue}
                                                    namePrefix="adHocClauses"
                                                    disabled={isNewLease || isInHanded}
                                                    leaseClauseTypes={leaseClauseTypes}
                                                    leaseClauses={adHocClauses}
                                                />
                                            </div>
                                        )}
                                    </>
                                )}

                                <div ref={acknowledgementSec}>
                                    <RHFLegend title="Acknowledgment & Signature" />
                                    {/* <AcknowledgementComponent acknowledgement={acknowledgement} states={!!states ? states?.items : []} /> */}
                                    <div style={{ margin: '2rem' }}>
                                        <AcknowledgementList
                                            acknowledgements={!!leaseData?.acknowledgements ? leaseData.acknowledgements : []}
                                            acknowledgementType={!!acknowledgementTypes ? acknowledgementTypes : []}
                                            states={!!states ? states?.items : []}
                                            olderVersions={hasOlderTemplates}
                                            invoiceableLookupId={leaseData?.invoiceableLookupId}
                                            refreshLease={refreshLease}
                                            isNewLease={isNewLease || isInHanded}
                                            hideDialog={hideDialog}
                                        />
                                    </div>
                                </div>

                                <div ref={docManagSection} style={{ marginBottom: '2rem' }}>
                                    <RHFLegend title="Manage Documents" />
                                    {/* add Document Management here */}
                                    <AgreementDocs
                                        generateLPR={showLPRPDFDialog}
                                        generateLease={showLeasePDFDialog}
                                        generateMemo={showMemoPDFDialog}
                                        generateOop={showOopPDFDialog}
                                        isNewLease={isNewLease}
                                        contextType={LandContractType.OilAndGas}
                                        leaseNumber={parseInt(leaseData?.leaseNumber, 10)}
                                        refreshMORs={refreshTractMORs}
                                        updateOlderVersions={(olderVersions) => setHasOlderTemplates(olderVersions)}
                                        filesToUpload={tractMORList}
                                        contractLookupId={parentContractLookupId}
                                    />
                                </div>

                                <div ref={pmSection} style={{ marginBottom: '4rem' }}>
                                    <RHFLegend title="Processing and Maintenance" />
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            justifyContent: 'space-around',
                                            rowGap: '1rem',
                                            marginBottom: '2rem',
                                        }}
                                    >
                                        <RHFInputBox label="Volume" name="volume" register={register} type="text" errors={errors} bodyStyle={{ width: '150px' }} />
                                        <RHFInputBox label="Page" name="page" register={register} type="text" errors={errors} bodyStyle={{ width: '150px' }} />
                                        <RHFInputBox label="Inst. Number" name="instrumentNumber" register={register} type="text" errors={errors} bodyStyle={{ width: '150px' }} />
                                        <RHFInputBox
                                            label="Recorded Date"
                                            name="recordedDate"
                                            register={register}
                                            type="date"
                                            errors={errors}
                                            bodyStyle={{ width: '150px' }}
                                        />
                                    </div>
                                    <div style={{ margin: '2rem 2rem 0 2rem' }}>
                                        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                            <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Option Management</legend>
                                        </fieldset>
                                        <div style={{ display: 'none' }}>
                                            <RHFToggle
                                                name="leasehold.optionExercised"
                                                label="Exercise Option"
                                                register={register}
                                                errors={errors}
                                            />
                                        </div>
                                        <Button
                                            className="blue-hover-button"
                                            text="Exercise Option"
                                            onClick={exerciseOption}
                                            disabled={isNewLease || isInHanded}
                                            style={{ marginTop: '1rem' }}
                                        />
                                    </div>
                                    <div ref={lrSection} style={{ marginBottom: '4rem' }}>
                                        <RHFLegend title="Lease Recording" />
                                        {leaseRecordData?.map((lr, index) => {
                                            return <div
                                                style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    justifyContent: 'space-around',
                                                    rowGap: '1rem',
                                                    marginBottom: '2rem',
                                                }}
                                                key={index}
                                            >
                                                <RHFInputBox
                                                    label="Invoice Date"
                                                    name={`leaseRecords[${index}].inv_date`}
                                                    defaultVal={moment(lr.inv_date)?.format('YYYY-MM-DD') || undefined}
                                                    errors={errors}
                                                    type="date"
                                                    bodyStyle={{ width: '150px' }}
                                                    disabled={true}
                                                />
                                                <RHFInputBox
                                                    label="Book"
                                                    name={`leaseRecords[${index}].book`}
                                                    defaultVal={lr.book?.toString()}
                                                    register={register}
                                                    errors={errors}
                                                    bodyStyle={{ width: '150px' }}
                                                    disabled={true}
                                                />
                                                <RHFInputBox
                                                    label="Page"
                                                    name={`leaseRecords[${index}].page`}
                                                    defaultVal={lr.page?.toString()}
                                                    register={register}
                                                    errors={errors}
                                                    bodyStyle={{ width: '150px' }}
                                                    disabled={true}
                                                />
                                                <RHFInputBox
                                                    label="County"
                                                    name={`leaseRecords[${index}].county`}
                                                    defaultVal={lr?.county || ''}
                                                    register={register}
                                                    errors={errors}
                                                    bodyStyle={{ width: '150px' }}
                                                    disabled={true}
                                                />
                                                <RHFInputBox
                                                    label="State"
                                                    name={`leaseRecords[${index}].state`}
                                                    defaultVal={lr?.state || ''}
                                                    register={register}
                                                    errors={errors}
                                                    bodyStyle={{ width: '150px' }}
                                                    disabled={true}
                                                />
                                                <RHFInputBox
                                                    label="Recording Date"
                                                    name={`leaseRecords[${index}].rec_date`}
                                                    defaultVal={moment(lr.rec_date)?.format('YYYY-MM-DD') || undefined}
                                                    register={register}
                                                    errors={errors}
                                                    type="date"
                                                    bodyStyle={{ width: '150px' }}
                                                    disabled={true}
                                                />
                                            </div>;
                                        })}
                                    </div>
                                    <div ref={pmAdmendmentSec} style={{ margin: '2rem 2rem 0 2rem' }}>
                                        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                            <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Amendments</legend>
                                        </fieldset>
                                        <div>
                                            <Button
                                                className="blue-hover-button"
                                                text="Add Amendment"
                                                onClick={addAmendment}
                                                disabled={/*disabling for now - feature is POC*/true || isNewLease}
                                                style={{ marginTop: '1rem' }}
                                            />
                                        </div>
                                        <div>{displayAmendments()}</div>
                                    </div>
                                </div>
                                {/*<div>
                                <RHFLegend title="Signature Blocks" />
                                <div style={{ margin: '2rem' }}>
                                    <SignatureList signatures={[{}, {}, {}]} />
                                </div>
                            </div>*/}
                                {/* <div style={{ marginTop: '1.5rem', borderTop: '1px solid grey', paddingTop: '1.5rem' }}>
                                <Button text="Save" type="submit" intent="primary" />
                            </div> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* <div>
                <RHFLegend title="Maintenance" />
            </div> */}

            {/* <div>
                <RHFLegend title="Invoicing" />
            </div> */}

            <LPRDialog leaseData={leaseData} location={location} />
            <ExtendLeaseholdsDialog
                dialogName={DialogList.EXTEND_LEASEHOLDS}
                leaseholds={leaseData?.leaseholds}
                resetForm={resetLeaseholdsExtension}
            />
            {/* Conditionality Rendering Memo */}
            {!!renderMemo && (
                <AethonMemo leaseData={leaseData} leaseClauses={contractClauses} leaseClauseTypes={leaseClauseTypes} location={location} />
            )}
            {/* Conditionality Rendering OOP */}
            {!!renderOOP && (
                <AethonOOP leaseData={leaseData} leaseClauses={contractClauses} leaseClauseTypes={leaseClauseTypes} location={location} />
            )}

            {/* Conditionality Rendering Lease */}
            {/* {!!renderTemplate && renderTemplate !== 2 && (
                <PDFWindow>
                    <DemoLease contractData={leaseData} leaseClauses={contractClauses} leaseClauseTypes={leaseClauseTypes} />
                </PDFWindow>
            )}
 */}
            {!!renderTemplate && (
                <PDFWindow>
                    <AethonLease contractData={leaseData} leaseClauses={contractClauses} leaseClauseTypes={leaseClauseTypes} location={location} />
                </PDFWindow>
            )}
            {/* {!!renderTemplate && renderTemplate === 3 && (
                <PDFWindow>
                    <FormonteraLease contractData={leaseData} leaseClauses={contractClauses} leaseClauseTypes={leaseClauseTypes} location={location} />
                </PDFWindow>
            )} */}
        </div>
    );
};

export default LeaseGeneration;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/LeaseGeneration.redesign.tsx